var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _ellipse, _path74, _path75, _path76, _path77, _rect, _path78, _path79, _circle, _circle2, _path80, _circle3, _circle4, _circle5, _path81, _path82, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _path94, _path95, _path96, _path97, _path98, _path99, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _path100, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _path101, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _circle234, _circle235, _circle236, _circle237, _circle238, _circle239, _circle240, _circle241, _circle242, _circle243, _circle244, _circle245, _circle246, _circle247, _circle248, _circle249, _circle250, _circle251, _circle252, _circle253, _circle254, _circle255, _circle256, _circle257, _circle258, _circle259, _circle260, _circle261, _circle262, _circle263, _circle264, _circle265, _circle266, _circle267, _circle268, _circle269, _circle270, _circle271, _circle272, _circle273, _circle274, _circle275, _circle276, _circle277, _circle278, _circle279, _circle280, _circle281, _circle282, _circle283, _circle284, _circle285, _circle286, _circle287, _circle288, _circle289, _circle290, _circle291, _circle292, _circle293, _circle294, _circle295, _circle296, _circle297, _circle298, _circle299, _circle300, _circle301, _circle302, _circle303, _circle304, _circle305, _circle306, _circle307, _circle308, _circle309, _circle310, _circle311, _circle312, _circle313, _circle314, _circle315, _circle316, _circle317, _circle318, _circle319, _circle320, _circle321, _circle322, _circle323, _circle324, _circle325, _circle326, _circle327, _circle328, _circle329, _circle330, _circle331, _circle332, _circle333, _circle334, _circle335, _circle336, _circle337, _circle338, _circle339, _circle340, _circle341, _circle342, _circle343, _circle344, _circle345, _circle346, _circle347, _circle348, _circle349, _circle350, _circle351, _circle352, _circle353, _circle354, _circle355, _circle356, _circle357, _circle358, _circle359, _circle360, _circle361, _circle362, _circle363, _circle364, _circle365, _circle366, _circle367, _circle368, _circle369, _circle370, _circle371, _circle372, _circle373, _circle374, _circle375, _circle376, _circle377, _circle378, _circle379, _circle380, _circle381, _circle382, _circle383, _circle384, _circle385, _circle386, _circle387, _circle388, _circle389, _circle390, _circle391, _circle392, _circle393, _circle394, _circle395, _circle396, _circle397, _circle398, _circle399, _circle400, _circle401, _circle402, _circle403, _circle404, _circle405, _circle406, _circle407, _circle408, _circle409, _circle410, _circle411, _circle412, _circle413, _circle414, _circle415, _circle416, _circle417, _circle418, _circle419, _circle420, _circle421, _circle422, _circle423, _circle424, _circle425, _circle426, _circle427, _circle428, _circle429, _circle430, _circle431, _circle432, _circle433, _circle434, _circle435, _circle436, _circle437, _circle438, _circle439, _circle440, _circle441, _circle442, _circle443, _circle444, _circle445, _circle446, _circle447, _circle448, _circle449, _circle450, _circle451, _circle452, _circle453, _circle454, _circle455, _circle456, _circle457, _circle458, _circle459, _circle460, _circle461, _circle462, _circle463, _circle464, _circle465, _circle466, _circle467, _circle468, _circle469, _circle470, _circle471, _circle472, _circle473, _circle474, _circle475, _circle476, _circle477, _circle478, _circle479, _circle480, _circle481, _circle482, _circle483, _circle484, _circle485, _circle486, _circle487, _circle488, _circle489, _circle490, _circle491, _circle492, _circle493, _circle494, _circle495, _circle496, _circle497, _circle498, _circle499, _circle500, _circle501, _circle502, _circle503, _circle504, _circle505, _circle506, _circle507, _circle508, _circle509, _circle510, _circle511, _circle512, _circle513, _circle514, _circle515, _circle516, _circle517, _circle518, _circle519, _circle520, _circle521, _circle522, _circle523, _circle524, _circle525, _circle526, _circle527, _circle528, _circle529, _circle530, _circle531, _circle532, _circle533, _circle534, _circle535, _circle536, _circle537, _circle538, _circle539, _circle540, _circle541, _circle542, _circle543, _circle544, _circle545, _circle546, _circle547, _circle548, _circle549, _circle550, _circle551, _circle552, _circle553, _circle554, _circle555, _circle556, _circle557, _circle558, _circle559, _circle560, _circle561, _circle562, _circle563, _circle564, _circle565, _circle566, _circle567, _circle568, _circle569, _circle570, _circle571, _circle572, _circle573, _circle574, _circle575, _circle576, _circle577, _circle578, _circle579, _circle580, _circle581, _circle582, _circle583, _circle584, _circle585, _circle586, _circle587, _circle588, _circle589, _circle590, _circle591, _circle592, _circle593, _circle594, _circle595, _circle596, _circle597, _circle598, _circle599, _circle600, _circle601, _circle602, _circle603, _circle604, _circle605, _circle606, _circle607, _circle608, _circle609, _circle610, _circle611, _circle612, _circle613, _circle614, _circle615, _circle616, _circle617, _circle618, _circle619, _circle620, _circle621, _circle622, _circle623, _circle624, _circle625, _circle626, _circle627, _circle628, _circle629, _circle630, _circle631, _circle632, _circle633, _circle634, _circle635, _circle636, _circle637, _circle638, _circle639, _circle640, _circle641, _circle642, _circle643, _circle644, _circle645, _circle646, _circle647, _circle648, _circle649, _circle650, _circle651, _circle652, _circle653, _circle654, _circle655, _circle656, _circle657, _circle658, _circle659, _circle660, _circle661, _circle662, _circle663, _circle664, _circle665, _circle666, _circle667, _circle668, _circle669, _circle670, _circle671, _circle672, _circle673, _circle674, _circle675, _circle676, _circle677, _circle678, _circle679, _circle680, _circle681, _circle682, _circle683, _circle684, _circle685, _circle686, _circle687, _circle688, _circle689, _circle690, _circle691, _circle692, _circle693, _circle694, _circle695, _circle696, _circle697, _circle698, _circle699, _circle700, _circle701, _circle702, _circle703, _circle704, _circle705, _circle706, _circle707, _circle708, _circle709, _circle710, _circle711, _circle712, _circle713, _circle714, _circle715, _circle716, _circle717, _circle718, _circle719, _circle720, _circle721, _circle722, _circle723, _circle724, _circle725, _circle726, _circle727, _circle728, _circle729, _circle730, _circle731, _circle732, _circle733, _circle734, _circle735, _circle736, _circle737, _circle738, _circle739, _circle740, _circle741, _circle742, _circle743, _circle744, _circle745, _circle746, _circle747, _circle748, _circle749, _circle750, _circle751, _circle752, _circle753, _circle754, _circle755, _circle756, _circle757, _circle758, _circle759, _circle760, _circle761, _circle762, _circle763, _circle764, _circle765, _circle766, _circle767, _circle768, _circle769, _circle770, _circle771, _circle772, _circle773, _circle774, _circle775, _circle776, _circle777, _circle778, _circle779, _circle780, _circle781, _circle782, _circle783, _circle784, _circle785, _circle786, _circle787, _circle788, _circle789, _circle790, _circle791, _circle792, _circle793, _circle794, _circle795, _circle796, _circle797, _circle798, _circle799, _circle800, _circle801, _circle802, _circle803, _circle804, _circle805, _circle806, _circle807, _circle808, _circle809, _circle810, _circle811, _circle812, _circle813, _circle814, _circle815, _circle816, _circle817, _circle818, _circle819, _circle820, _circle821, _circle822, _circle823, _circle824, _circle825, _circle826, _circle827, _circle828, _circle829, _circle830, _circle831, _circle832, _circle833, _circle834, _circle835, _circle836, _circle837, _circle838, _circle839, _circle840, _circle841, _circle842, _circle843, _circle844, _circle845, _circle846, _circle847, _circle848, _circle849, _circle850, _circle851, _circle852, _circle853, _circle854, _circle855, _circle856, _circle857, _circle858, _circle859, _circle860, _circle861, _circle862, _circle863, _circle864, _circle865, _circle866, _circle867, _circle868, _circle869, _circle870, _circle871, _circle872, _circle873, _circle874, _circle875, _circle876, _circle877, _circle878, _circle879, _circle880, _circle881, _circle882, _circle883, _circle884, _circle885, _circle886, _circle887, _circle888, _circle889, _circle890, _circle891, _circle892, _circle893, _circle894, _circle895, _circle896, _circle897, _circle898, _circle899, _circle900, _circle901, _circle902, _circle903, _circle904, _circle905, _circle906, _circle907, _circle908, _circle909, _circle910, _circle911, _circle912, _circle913, _circle914, _circle915, _circle916, _circle917, _circle918, _circle919, _circle920, _circle921, _circle922, _circle923, _circle924, _circle925, _circle926, _circle927, _circle928, _circle929, _circle930, _circle931, _circle932, _circle933, _circle934, _circle935, _circle936, _circle937, _circle938, _circle939, _circle940, _circle941, _circle942, _circle943, _circle944, _circle945, _circle946, _circle947, _circle948, _circle949, _circle950, _circle951, _circle952, _circle953, _circle954, _circle955, _circle956, _circle957, _circle958, _circle959, _circle960, _circle961, _circle962, _circle963, _circle964, _circle965, _circle966, _circle967, _circle968, _circle969, _circle970, _circle971, _circle972, _circle973, _circle974, _circle975, _circle976, _circle977, _circle978, _circle979, _circle980, _circle981, _circle982, _circle983, _circle984, _circle985, _circle986, _circle987, _circle988, _circle989, _circle990, _circle991, _circle992, _circle993, _circle994, _circle995, _circle996, _circle997, _circle998, _circle999, _circle1000, _circle1001, _circle1002, _circle1003, _circle1004, _circle1005, _circle1006, _circle1007, _circle1008, _circle1009, _circle1010, _circle1011, _circle1012, _circle1013, _circle1014, _circle1015, _circle1016, _circle1017, _circle1018, _circle1019, _circle1020, _circle1021, _circle1022, _circle1023, _circle1024, _circle1025, _circle1026, _circle1027, _circle1028, _circle1029, _circle1030, _circle1031, _circle1032, _circle1033, _circle1034, _circle1035, _circle1036, _circle1037, _circle1038, _circle1039, _circle1040, _circle1041, _circle1042, _circle1043, _circle1044, _circle1045, _circle1046, _circle1047, _circle1048, _circle1049, _circle1050, _circle1051, _circle1052, _circle1053, _circle1054, _circle1055, _circle1056, _circle1057, _circle1058, _circle1059, _circle1060, _circle1061, _circle1062, _circle1063, _circle1064, _circle1065, _circle1066, _circle1067, _circle1068, _circle1069, _circle1070, _circle1071, _circle1072, _circle1073, _circle1074, _circle1075, _circle1076, _circle1077, _circle1078, _circle1079, _circle1080, _circle1081, _circle1082, _circle1083, _circle1084, _circle1085, _circle1086, _circle1087, _circle1088, _circle1089, _circle1090, _circle1091, _circle1092, _circle1093, _circle1094, _circle1095, _circle1096, _circle1097, _circle1098, _circle1099, _circle1100, _circle1101, _circle1102, _circle1103, _circle1104, _circle1105, _circle1106, _circle1107, _circle1108, _circle1109, _circle1110, _circle1111, _circle1112, _circle1113, _circle1114, _circle1115, _circle1116, _circle1117, _circle1118, _circle1119, _circle1120, _circle1121, _circle1122, _circle1123, _circle1124, _circle1125, _circle1126, _circle1127, _circle1128, _circle1129, _circle1130, _circle1131, _circle1132, _circle1133, _circle1134, _circle1135, _circle1136, _circle1137, _circle1138, _circle1139, _circle1140, _circle1141, _circle1142, _circle1143, _circle1144, _circle1145, _circle1146, _circle1147, _circle1148, _circle1149, _circle1150, _circle1151, _circle1152, _circle1153, _circle1154, _circle1155, _circle1156, _circle1157, _circle1158, _circle1159, _circle1160, _circle1161, _circle1162, _circle1163, _circle1164, _circle1165, _circle1166, _circle1167, _circle1168, _circle1169, _circle1170, _circle1171, _circle1172, _circle1173, _circle1174, _circle1175, _circle1176, _circle1177, _circle1178, _circle1179, _circle1180, _circle1181, _circle1182, _circle1183, _circle1184, _circle1185, _circle1186, _circle1187, _circle1188, _circle1189, _circle1190, _circle1191, _circle1192, _circle1193, _circle1194, _circle1195, _circle1196, _circle1197, _circle1198, _circle1199, _circle1200, _circle1201, _circle1202, _circle1203, _circle1204, _circle1205, _circle1206, _circle1207, _circle1208, _circle1209, _circle1210, _circle1211, _circle1212, _circle1213, _circle1214, _circle1215, _circle1216, _circle1217, _circle1218, _circle1219, _circle1220, _circle1221, _circle1222, _circle1223, _circle1224, _circle1225, _circle1226, _circle1227, _circle1228, _circle1229, _circle1230, _circle1231, _circle1232, _circle1233, _circle1234, _circle1235, _circle1236, _circle1237, _circle1238, _circle1239, _circle1240, _circle1241, _circle1242, _circle1243, _circle1244, _circle1245, _circle1246, _circle1247, _circle1248, _circle1249, _circle1250, _circle1251, _circle1252, _circle1253, _circle1254, _circle1255, _circle1256, _circle1257, _circle1258, _circle1259, _circle1260, _circle1261, _circle1262, _circle1263, _circle1264, _circle1265, _circle1266, _circle1267, _circle1268, _circle1269, _circle1270, _circle1271, _circle1272, _circle1273, _circle1274, _circle1275, _circle1276, _circle1277, _circle1278, _circle1279, _circle1280, _circle1281, _circle1282, _circle1283, _circle1284, _circle1285, _circle1286, _circle1287, _circle1288, _circle1289, _circle1290, _circle1291, _circle1292, _circle1293, _circle1294, _circle1295, _circle1296, _circle1297, _circle1298, _circle1299, _circle1300, _circle1301, _circle1302, _circle1303, _circle1304, _circle1305, _circle1306, _circle1307, _circle1308, _circle1309, _circle1310, _circle1311, _circle1312, _circle1313, _circle1314, _circle1315, _circle1316, _circle1317, _circle1318, _circle1319, _circle1320, _circle1321, _circle1322, _circle1323, _circle1324, _circle1325, _circle1326, _circle1327, _circle1328, _circle1329, _circle1330, _circle1331, _circle1332, _circle1333, _circle1334, _circle1335, _circle1336, _circle1337, _circle1338, _circle1339, _circle1340, _circle1341, _circle1342, _circle1343, _circle1344, _circle1345, _circle1346, _circle1347, _circle1348, _circle1349, _circle1350, _circle1351, _circle1352, _circle1353, _circle1354, _circle1355, _circle1356, _circle1357, _circle1358, _circle1359, _circle1360, _circle1361, _circle1362, _circle1363, _circle1364, _circle1365, _circle1366, _circle1367, _circle1368, _circle1369, _circle1370, _circle1371, _circle1372, _circle1373, _circle1374, _circle1375, _circle1376, _circle1377, _circle1378, _circle1379, _circle1380, _circle1381, _circle1382, _circle1383, _circle1384, _circle1385, _circle1386, _circle1387, _circle1388, _circle1389, _circle1390, _circle1391, _circle1392, _circle1393, _circle1394, _circle1395, _circle1396, _circle1397, _circle1398, _circle1399, _circle1400, _circle1401, _circle1402, _circle1403, _circle1404, _circle1405, _circle1406, _circle1407, _circle1408, _circle1409, _circle1410, _circle1411, _circle1412, _circle1413, _circle1414, _circle1415, _circle1416, _circle1417, _circle1418, _circle1419, _circle1420, _circle1421, _circle1422, _circle1423, _circle1424, _circle1425, _circle1426, _circle1427, _circle1428, _circle1429, _circle1430, _circle1431, _circle1432, _circle1433, _circle1434, _circle1435, _circle1436, _circle1437, _circle1438, _circle1439, _circle1440, _circle1441, _circle1442, _circle1443, _circle1444, _circle1445, _circle1446, _circle1447, _circle1448, _circle1449, _circle1450, _circle1451, _circle1452, _circle1453, _circle1454, _circle1455, _circle1456, _circle1457, _circle1458, _circle1459, _circle1460, _circle1461, _circle1462, _circle1463, _circle1464, _circle1465, _circle1466, _circle1467, _circle1468, _circle1469, _circle1470, _circle1471, _circle1472, _circle1473, _circle1474, _circle1475, _circle1476, _circle1477, _circle1478, _circle1479, _circle1480, _circle1481, _circle1482, _circle1483, _circle1484, _circle1485, _circle1486, _circle1487, _circle1488, _circle1489, _circle1490, _circle1491, _circle1492, _circle1493, _circle1494, _circle1495, _circle1496, _circle1497, _circle1498, _circle1499, _circle1500, _circle1501, _circle1502, _circle1503, _circle1504, _circle1505, _circle1506, _circle1507, _circle1508, _circle1509, _circle1510, _circle1511, _circle1512, _circle1513, _circle1514, _circle1515, _circle1516, _circle1517, _circle1518, _circle1519, _circle1520, _circle1521, _circle1522, _circle1523, _circle1524, _circle1525, _circle1526, _circle1527, _circle1528, _circle1529, _circle1530, _circle1531, _circle1532, _circle1533, _circle1534, _circle1535, _circle1536, _circle1537, _circle1538, _circle1539, _circle1540, _circle1541, _circle1542, _circle1543, _circle1544, _circle1545, _circle1546, _circle1547, _circle1548, _circle1549, _circle1550, _circle1551, _circle1552, _circle1553, _circle1554, _circle1555, _circle1556, _circle1557, _circle1558, _circle1559, _circle1560, _circle1561, _circle1562, _circle1563, _circle1564, _circle1565, _circle1566, _circle1567, _circle1568, _circle1569, _circle1570, _circle1571, _circle1572, _circle1573, _circle1574, _circle1575, _circle1576, _circle1577, _circle1578, _circle1579, _circle1580, _circle1581, _circle1582, _circle1583, _circle1584, _circle1585, _circle1586, _circle1587, _circle1588, _circle1589, _circle1590, _circle1591, _circle1592, _circle1593, _circle1594, _circle1595, _circle1596, _circle1597, _circle1598, _circle1599, _circle1600, _circle1601, _circle1602, _circle1603, _circle1604, _circle1605, _circle1606, _circle1607, _circle1608, _circle1609, _circle1610, _circle1611, _circle1612, _circle1613, _circle1614, _circle1615, _circle1616, _circle1617, _circle1618, _circle1619, _circle1620, _circle1621, _circle1622, _circle1623, _circle1624, _circle1625, _circle1626, _circle1627, _circle1628, _circle1629, _circle1630, _circle1631, _circle1632, _circle1633, _circle1634, _circle1635, _circle1636, _circle1637, _circle1638, _circle1639, _circle1640, _circle1641, _circle1642, _circle1643, _circle1644, _circle1645, _circle1646, _circle1647, _circle1648, _circle1649, _circle1650, _circle1651, _circle1652, _circle1653, _circle1654, _circle1655, _circle1656, _circle1657, _circle1658, _circle1659, _circle1660, _circle1661, _circle1662, _circle1663, _circle1664, _circle1665, _circle1666, _circle1667, _circle1668, _circle1669, _circle1670, _circle1671, _circle1672, _circle1673, _circle1674, _circle1675, _circle1676, _circle1677, _circle1678, _circle1679, _circle1680, _circle1681, _circle1682, _circle1683, _circle1684, _circle1685, _circle1686, _circle1687, _circle1688, _circle1689, _circle1690, _circle1691, _circle1692, _circle1693, _circle1694, _circle1695, _circle1696, _circle1697, _circle1698, _circle1699, _circle1700, _circle1701, _circle1702, _circle1703, _circle1704, _circle1705, _circle1706, _circle1707, _circle1708, _circle1709, _circle1710, _circle1711, _circle1712, _circle1713, _circle1714, _circle1715, _circle1716, _circle1717, _circle1718, _circle1719, _circle1720, _circle1721, _circle1722, _circle1723, _circle1724, _circle1725, _circle1726, _circle1727, _circle1728, _circle1729, _circle1730, _circle1731, _circle1732, _circle1733, _circle1734, _circle1735, _circle1736, _circle1737, _circle1738, _circle1739, _circle1740, _circle1741, _circle1742, _circle1743, _circle1744, _circle1745, _circle1746, _circle1747, _circle1748, _circle1749, _circle1750, _circle1751, _circle1752, _circle1753, _circle1754, _circle1755, _circle1756, _circle1757, _circle1758, _circle1759, _circle1760, _circle1761, _circle1762, _circle1763, _circle1764, _circle1765, _circle1766, _circle1767, _circle1768, _circle1769, _circle1770, _circle1771, _circle1772, _circle1773, _circle1774, _circle1775, _circle1776, _circle1777, _circle1778, _circle1779, _circle1780, _circle1781, _circle1782, _circle1783, _circle1784, _circle1785, _circle1786, _circle1787, _circle1788, _circle1789, _circle1790, _circle1791, _circle1792, _circle1793, _circle1794, _circle1795, _circle1796, _circle1797, _circle1798, _circle1799, _circle1800, _circle1801, _circle1802, _circle1803, _circle1804, _circle1805, _circle1806, _circle1807, _circle1808, _circle1809, _circle1810, _circle1811, _circle1812, _circle1813, _circle1814, _circle1815, _circle1816, _circle1817, _circle1818, _circle1819, _circle1820, _circle1821, _circle1822, _circle1823, _circle1824, _circle1825, _circle1826, _circle1827, _circle1828, _circle1829, _circle1830, _circle1831, _circle1832, _circle1833, _circle1834, _circle1835, _circle1836, _circle1837, _circle1838, _circle1839, _circle1840, _circle1841, _circle1842, _circle1843, _circle1844, _circle1845, _circle1846, _circle1847, _circle1848, _circle1849, _circle1850, _circle1851, _circle1852, _circle1853, _circle1854, _circle1855, _circle1856, _circle1857, _circle1858, _circle1859, _circle1860, _circle1861, _circle1862, _circle1863, _circle1864, _circle1865, _circle1866, _circle1867, _circle1868, _circle1869, _circle1870, _circle1871, _circle1872, _circle1873, _circle1874, _circle1875, _circle1876, _circle1877, _circle1878, _circle1879, _circle1880, _circle1881, _circle1882, _circle1883, _circle1884, _circle1885, _circle1886, _circle1887, _circle1888, _circle1889, _circle1890, _circle1891, _circle1892, _circle1893, _circle1894, _circle1895, _circle1896, _circle1897, _circle1898, _circle1899, _circle1900, _circle1901, _circle1902, _circle1903, _circle1904, _circle1905, _circle1906, _circle1907, _circle1908, _circle1909, _circle1910, _circle1911, _circle1912, _circle1913, _circle1914, _circle1915, _circle1916, _circle1917, _circle1918, _circle1919, _circle1920, _circle1921, _circle1922, _circle1923, _circle1924, _circle1925, _circle1926, _circle1927, _circle1928, _circle1929, _circle1930, _circle1931, _circle1932, _circle1933, _circle1934, _circle1935, _circle1936, _circle1937, _circle1938, _circle1939, _circle1940, _circle1941, _circle1942, _circle1943, _circle1944, _circle1945, _circle1946, _circle1947, _circle1948, _circle1949, _circle1950, _circle1951, _circle1952, _circle1953, _circle1954, _circle1955, _circle1956, _circle1957, _circle1958, _circle1959, _circle1960, _circle1961, _circle1962, _circle1963, _circle1964, _circle1965, _circle1966, _circle1967, _circle1968, _circle1969, _circle1970, _circle1971, _circle1972, _circle1973, _circle1974, _circle1975, _circle1976, _circle1977, _circle1978, _circle1979, _circle1980, _circle1981, _circle1982, _circle1983, _circle1984, _circle1985, _circle1986, _circle1987, _circle1988, _circle1989, _circle1990, _circle1991, _circle1992, _circle1993, _circle1994, _circle1995, _circle1996, _circle1997, _circle1998, _circle1999, _circle2000, _circle2001, _circle2002, _circle2003, _circle2004, _circle2005, _circle2006, _circle2007, _circle2008, _circle2009, _circle2010, _circle2011, _circle2012, _circle2013, _circle2014, _circle2015, _circle2016, _circle2017, _circle2018, _circle2019, _circle2020, _circle2021, _circle2022, _circle2023, _circle2024, _circle2025, _circle2026, _circle2027, _circle2028, _circle2029, _circle2030, _circle2031, _circle2032, _circle2033, _circle2034, _circle2035, _circle2036, _circle2037, _circle2038, _circle2039, _circle2040, _circle2041, _circle2042, _circle2043, _circle2044, _circle2045, _circle2046, _circle2047, _circle2048, _circle2049, _circle2050, _circle2051, _circle2052, _circle2053, _circle2054, _circle2055, _circle2056, _circle2057, _circle2058, _circle2059, _circle2060, _circle2061, _circle2062, _circle2063, _circle2064, _circle2065, _circle2066, _circle2067, _circle2068, _circle2069, _circle2070, _circle2071, _circle2072, _circle2073, _circle2074, _circle2075, _circle2076, _circle2077, _circle2078, _circle2079, _circle2080, _circle2081, _circle2082, _path102, _circle2083, _circle2084, _circle2085, _circle2086, _circle2087, _circle2088, _circle2089, _circle2090, _circle2091, _circle2092, _circle2093, _circle2094, _circle2095, _circle2096, _circle2097, _circle2098, _circle2099, _circle2100, _circle2101, _circle2102, _circle2103, _circle2104, _circle2105, _circle2106, _circle2107, _circle2108, _circle2109, _circle2110, _circle2111, _circle2112, _circle2113, _circle2114, _circle2115, _circle2116, _circle2117, _circle2118, _circle2119, _circle2120, _circle2121, _circle2122, _circle2123, _circle2124, _circle2125, _circle2126, _circle2127, _circle2128, _circle2129, _circle2130, _circle2131, _circle2132, _circle2133, _circle2134, _circle2135, _circle2136, _circle2137, _circle2138, _circle2139, _circle2140, _circle2141, _circle2142, _circle2143, _circle2144, _circle2145, _circle2146, _circle2147, _circle2148, _circle2149, _circle2150, _circle2151, _circle2152, _circle2153, _circle2154, _circle2155, _circle2156, _circle2157, _circle2158, _circle2159, _circle2160, _circle2161, _circle2162, _circle2163, _circle2164, _circle2165, _circle2166, _circle2167, _circle2168, _circle2169, _circle2170, _circle2171, _circle2172, _circle2173, _circle2174, _circle2175, _circle2176, _circle2177, _circle2178, _circle2179, _circle2180, _circle2181, _circle2182, _circle2183, _circle2184, _circle2185, _circle2186, _circle2187, _circle2188, _circle2189, _circle2190, _circle2191, _circle2192, _circle2193, _circle2194, _circle2195, _circle2196, _circle2197, _circle2198, _circle2199, _circle2200, _circle2201, _circle2202, _circle2203, _circle2204, _circle2205, _circle2206, _circle2207, _circle2208, _circle2209, _circle2210, _circle2211, _circle2212, _circle2213, _circle2214, _circle2215, _circle2216, _circle2217, _circle2218, _circle2219, _circle2220, _circle2221, _circle2222, _circle2223, _circle2224, _circle2225, _circle2226, _circle2227, _circle2228, _circle2229, _circle2230, _circle2231, _circle2232, _circle2233, _circle2234, _circle2235, _circle2236, _circle2237, _circle2238, _circle2239, _circle2240, _circle2241, _circle2242, _circle2243, _circle2244, _circle2245, _circle2246, _circle2247, _circle2248, _circle2249, _circle2250, _circle2251, _circle2252, _circle2253, _circle2254, _circle2255, _circle2256, _circle2257, _circle2258, _circle2259, _circle2260, _circle2261, _circle2262, _circle2263, _circle2264, _circle2265, _circle2266, _circle2267, _circle2268, _circle2269, _circle2270, _circle2271, _circle2272, _circle2273, _circle2274, _circle2275, _circle2276, _circle2277, _circle2278, _circle2279, _circle2280, _circle2281, _circle2282, _circle2283, _circle2284, _circle2285, _circle2286, _circle2287, _circle2288, _circle2289, _circle2290, _circle2291, _circle2292, _circle2293, _circle2294, _circle2295, _circle2296, _circle2297, _circle2298, _circle2299, _circle2300, _circle2301, _circle2302, _circle2303, _circle2304, _circle2305, _circle2306, _circle2307, _circle2308, _circle2309, _circle2310, _circle2311, _circle2312, _circle2313, _circle2314, _circle2315, _circle2316, _circle2317, _circle2318, _circle2319, _circle2320, _circle2321, _circle2322, _circle2323, _circle2324, _circle2325, _circle2326, _circle2327, _circle2328, _circle2329, _circle2330, _circle2331, _circle2332, _circle2333, _circle2334, _circle2335, _circle2336, _circle2337, _circle2338, _circle2339, _circle2340, _circle2341, _circle2342, _circle2343, _circle2344, _circle2345, _circle2346, _circle2347, _circle2348, _circle2349, _circle2350, _circle2351, _circle2352, _circle2353, _circle2354, _circle2355, _circle2356, _circle2357, _circle2358, _circle2359, _circle2360, _circle2361, _circle2362, _circle2363, _circle2364, _circle2365, _circle2366, _circle2367, _circle2368, _circle2369, _circle2370, _circle2371, _circle2372, _circle2373, _circle2374, _circle2375, _circle2376, _circle2377, _circle2378, _circle2379, _circle2380, _circle2381, _circle2382, _circle2383, _circle2384, _circle2385, _circle2386, _circle2387, _circle2388, _circle2389, _circle2390, _circle2391, _circle2392, _circle2393, _circle2394, _circle2395, _circle2396, _circle2397, _circle2398, _circle2399, _circle2400, _circle2401, _circle2402, _circle2403, _circle2404, _circle2405, _circle2406, _circle2407, _circle2408, _circle2409, _circle2410, _circle2411, _circle2412, _circle2413, _circle2414, _circle2415, _circle2416, _circle2417, _circle2418, _circle2419, _circle2420, _circle2421, _circle2422, _circle2423, _circle2424, _circle2425, _circle2426, _circle2427, _circle2428, _circle2429, _circle2430, _circle2431, _circle2432, _circle2433, _circle2434, _circle2435, _circle2436, _circle2437, _circle2438, _circle2439, _circle2440, _circle2441, _circle2442, _circle2443, _circle2444, _circle2445, _circle2446, _circle2447, _circle2448, _circle2449, _circle2450, _circle2451, _circle2452, _circle2453, _circle2454, _circle2455, _circle2456, _circle2457, _circle2458, _circle2459, _circle2460, _circle2461, _circle2462, _circle2463, _circle2464, _circle2465, _circle2466, _circle2467, _circle2468, _circle2469, _circle2470, _circle2471, _circle2472, _circle2473, _circle2474, _circle2475, _circle2476, _circle2477, _circle2478, _circle2479, _circle2480, _circle2481, _circle2482, _circle2483, _circle2484, _circle2485, _circle2486, _circle2487, _circle2488, _circle2489, _circle2490, _circle2491, _circle2492, _circle2493, _circle2494, _circle2495, _circle2496, _circle2497, _circle2498, _circle2499, _circle2500, _circle2501, _circle2502, _circle2503, _circle2504, _circle2505, _circle2506, _circle2507, _circle2508, _circle2509, _circle2510, _circle2511, _circle2512, _circle2513, _circle2514, _circle2515, _circle2516, _circle2517, _circle2518, _circle2519, _circle2520, _circle2521, _circle2522, _circle2523, _circle2524, _circle2525, _circle2526, _circle2527, _circle2528, _circle2529, _circle2530, _circle2531, _circle2532, _circle2533, _circle2534, _circle2535, _circle2536, _circle2537, _circle2538, _circle2539, _circle2540, _circle2541, _circle2542, _circle2543, _circle2544, _circle2545, _circle2546, _circle2547, _circle2548, _circle2549, _circle2550, _circle2551, _circle2552, _circle2553, _circle2554, _circle2555, _circle2556, _circle2557, _circle2558, _circle2559, _circle2560, _circle2561, _circle2562, _circle2563, _circle2564, _circle2565, _circle2566, _circle2567, _circle2568, _circle2569, _circle2570, _circle2571, _circle2572, _circle2573, _circle2574, _circle2575, _circle2576, _circle2577, _circle2578, _circle2579, _circle2580, _circle2581, _circle2582, _circle2583, _circle2584, _circle2585, _circle2586, _circle2587, _circle2588, _circle2589, _circle2590, _circle2591, _circle2592, _circle2593, _circle2594, _circle2595, _circle2596, _circle2597, _circle2598, _circle2599, _circle2600, _circle2601, _circle2602, _circle2603, _circle2604, _circle2605, _circle2606, _circle2607, _circle2608, _circle2609, _circle2610, _circle2611, _circle2612, _circle2613, _circle2614, _circle2615, _circle2616, _circle2617, _circle2618, _circle2619, _circle2620, _circle2621, _circle2622, _circle2623, _circle2624, _circle2625, _circle2626, _circle2627, _circle2628, _circle2629, _circle2630, _circle2631, _circle2632, _circle2633, _circle2634, _circle2635, _circle2636, _circle2637, _circle2638, _circle2639, _circle2640, _circle2641, _circle2642, _circle2643, _circle2644, _circle2645, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _circle2646, _circle2647, _circle2648, _circle2649, _circle2650, _circle2651, _circle2652, _circle2653, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _g, _path161, _path162, _ellipse2, _path163, _path164, _ellipse3, _path165, _path166;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 974.07,
    height: 840.06,
    viewBox: "0 0 974.07 840.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "840fda27-e84f-4eb3-b741-5710a211ee4f-101",
    x1: 942.83,
    y1: 529.56,
    x2: 942.83,
    y2: 529.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "198ff05b-1f86-443b-a19b-b69c2e52e16f-102",
    x1: 970.49,
    y1: 856.98,
    x2: 970.49,
    y2: 434.96,
    xlinkHref: "#840fda27-e84f-4eb3-b741-5710a211ee4f-101"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "world") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M399.78,62c31.51-28.08,81-33.81,126-31.57,141.44,7,269.11,75.31,379.54,152.54,40,28,79.34,58.1,105.3,96.6,52.82,78.38,37.15,187-36.31,251.53-25,22-55.29,38.82-86.39,53.75-55.3,26.54-115,47.85-177.75,53.92-44.76,4.32-90.07.8-134.57-5.23C451.28,616.66,329.24,579.37,227,515.58c-44.86-28-87.15-62.76-105.64-108s-6.66-102.62,39.15-129.41c18.95-11.08,41.6-16.08,63.78-20.78,32.64-6.92,65.81-13.74,95.27-27.8C349.94,215.05,386,187,380,154.82,373.48,120.32,368.3,90,399.78,62Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M413,682.34s9-10.15,21.19-7.92c0,0-1.61,7.32-15.48,10.38Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M411.76,683.08s.08,13.55,10.72,19.93c0,0,3.61-6.57-4.8-18Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M394.87,674.59s-2.08-11,23.19-13.94c0,0,2,6.91-5.67,12.5S400.09,677,394.87,674.59Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M393.36,674.91S384,681,399.25,701.32c0,0,6.37-3.34,5.14-12.73S398.7,677,393.36,674.91Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M375.5,663.34s-6.15-17.35,19.18-22.19c0,0,6.07,15.56-13.66,25.27Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M353.71,647.75s-2-21,24.46-21.68c0,0,4.75,17.34-19.12,25.37Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M336.16,630.29s.44-21.13,26.63-21.84c0,0-1.13,19.16-24,25Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M319.35,613.16s.12-21.79,25.51-22.07c0,0-2.75,21.4-23,25.11Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M306.85,596s-2.38-26,21.25-26.43c0,0-.38,24.31-18.65,29.6Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M293.74,574.62s-1.57-26.4,22.77-25.13c0,0-2.44,26-20.28,28.17Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M283.69,554.2s1.45-27.21,19-31.19c0,0-1.26,28.67-16.17,35.82Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33,533.88s.8-32.5,15.53-34c0,0,0,24.67-13.77,38.52Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M267,509.15s1.6-27.33,15.25-32.06c0,0,1,26.21-13.19,38.5Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M259.07,486.2s3.65-27.91,12.7-30.95c0,0,2.12,25.95-10.67,34.83Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M252.07,464.72s-.94-29,7.64-33.73c0,0,4.74,22.65-6.17,35.52Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M241,437.12s.88-23.54,7.43-28.86c0,0,5.41,26-4.28,33.72Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M233.05,419.16l-11.65-38s21.66,25.21,14.49,44.47Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M212.08,383.94s-17.53-25.32-20.35-26.23c0,0,24.52,12.89,28.87,36.78Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M374.78,663.39s-18.23,2.42-11,27.18c0,0,16.62-1.68,16.29-23.66Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M352.7,647.3s-20.38,5.4-11.88,30.44c0,0,17.91-1.53,17.19-26.71Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M336.41,632s-20.81-3.7-26.63,21.84c0,0,19,2.64,29.23-18.66Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M319,613.46s-21.39-4.15-26.64,20.69c0,0,21.54,1.5,29.13-17.66Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M307.24,596.42s-22.89-12.51-32.7,9c0,0,22.45,9.32,34.57-5.34Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M294.62,573.75s-23.11-12.87-32.53,9.61c0,0,24.49,9.08,34.18-6.05Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M285.37,553s-20.08-18.41-35.37-9c0,0,21,19.6,36.61,14.27Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M275.71,533.63s-21.75-24.17-33.88-15.7c0,0,16,18.75,35.51,20.3Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M267.64,507.46s-20.54-18.1-33.52-11.73c0,0,17.95,19.13,36.64,17.73Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M260.49,485.29s-18-21.67-27.24-19.41c0,0,12,23.08,27.59,23.77Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M252.38,464.06s-19.32-21.65-28.79-19.16c0,0,12.19,19.67,29,21.47Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M243.38,438.12s-15-18.19-23.41-18.44c0,0,11.49,24,23.85,24.21Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M231.74,418.74l-29.67-26.42S216,422.51,236.45,424Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M207.94,387.81s-29-10.32-30.62-12.81c0,0,18.83,20.31,43,18.29Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M204.44,380.61s-35.35-19.47-42.52-17.51c0,0,23.46-5.16,42.81,15.89Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M244.19,442.2l-1,.41c-16.38-39.92-30.63-62.27-40.14-63l.08-1.07C213.22,379.31,227.41,401.31,244.19,442.2Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#444053"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M278.48,538.94l-1.51.54c-1.36-3.77-2.67-7.65-3.9-11.54-10.65-33.81-21.37-64.61-30.7-87.35l.6-1.35c9.34,22.79,21,54.36,31.63,88.22C275.82,531.32,277.13,535.19,278.48,538.94Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#444053"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M447.13,694.27c-.3,0-30.79-4.9-66.83-26.31A232.48,232.48,0,0,1,324,621.16c-20.2-23.1-36.94-53.66-48.14-84.7l1.81.33c25.14,69.67,70.68,109.7,103.6,129.28,35.7,21.23,65.85,26,66.15,26.08Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#444053"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M412.29,524.85s9.06-10.08,21.25-7.77c0,0-1.66,7.31-15.55,10.27Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M411.05,525.58s0,13.55,10.57,20c0,0,3.66-6.54-4.66-18.05Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M394.22,517s-2-11,23.29-13.76c0,0,1.93,6.93-5.77,12.45S399.42,519.42,394.22,517Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M392.71,517.28s-9.44,6,5.7,26.44c0,0,6.39-3.29,5.23-12.69S398,519.43,392.71,517.28Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M374.93,505.57s-6-17.38,19.34-22.05c0,0,6,15.61-13.84,25.18Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M353.26,489.82s-1.83-21,24.61-21.49c0,0,4.63,17.37-19.3,25.23Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M335.84,472.24s.59-21.13,26.79-21.64c0,0-1.28,19.15-24.21,24.83Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M319.15,455s.28-21.8,25.67-21.89c0,0-2.91,21.39-23.21,24.94Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M306.77,437.69s-2.18-26,21.45-26.27c0,0-.56,24.3-18.87,29.46Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M293.83,416.26s-1.39-26.41,22.95-25c0,0-2.64,26-20.49,28Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M283.92,395.77s1.65-27.2,19.19-31c0,0-1.47,28.66-16.43,35.7Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M275.71,375.39s1-32.5,15.78-33.85c0,0-.16,24.67-14.05,38.42Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M267.6,350.6s1.8-27.32,15.48-32c0,0,.77,26.21-13.46,38.4Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M259.8,327.59s3.85-27.88,12.92-30.85c0,0,1.94,26-10.92,34.74Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M253,306.06s-.73-29,7.89-33.68c0,0,4.57,22.69-6.44,35.48Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M242.05,278.38s1-23.54,7.64-28.8c0,0,5.22,26.07-4.53,33.68Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M234.27,260.36,222.9,222.3s21.47,25.37,14.17,44.57Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M213.56,225s-17.34-25.45-20.16-26.38c0,0,24.42,13.07,28.6,37Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M374.22,505.62S356,507.91,363,532.72c0,0,16.63-1.56,16.46-23.54Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M352.25,489.37s-20.42,5.25-12.1,30.35c0,0,17.92-1.4,17.39-26.58Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M336.07,473.94s-20.78-3.85-26.79,21.65c0,0,19,2.77,29.37-18.45Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M318.78,455.28S297.42,451,292,475.78c0,0,21.52,1.65,29.26-17.45Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M307.16,438.16s-22.79-12.68-32.76,8.75c0,0,22.38,9.49,34.61-5.09Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M294.7,415.4s-23-13-32.59,9.37c0,0,24.42,9.26,34.22-5.8Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M285.61,394.56s-19.95-18.56-35.3-9.26c0,0,20.82,19.75,36.5,14.54Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M276.09,375.14s-21.57-24.33-33.77-15.95c0,0,15.89,18.87,35.37,20.56Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M268.21,348.92s-20.4-18.26-33.42-12c0,0,17.8,19.26,36.5,18Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M261.23,326.69s-17.81-21.8-27.1-19.61c0,0,11.86,23.17,27.42,24Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M253.27,305.4S234.11,283.61,224.62,286c0,0,12,19.76,28.8,21.68Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M244.47,279.4s-14.85-18.3-23.28-18.61c0,0,11.31,24.06,23.67,24.38Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M233,259.93l-29.47-26.64s13.67,30.3,34.15,32Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M209.39,228.83s-28.93-10.53-30.53-13c0,0,18.69,20.45,42.9,18.61Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M205.94,221.6s-35.2-19.72-42.38-17.82c0,0,23.49-5,42.68,16.21Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M245.24,283.48l-1,.4c-16.09-40-30.18-62.49-39.68-63.25l.08-1.06C214.73,220.37,228.76,242.47,245.24,283.48Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#444053"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M278.82,380.47l-1.51.53c-1.33-3.78-2.62-7.67-3.81-11.57-10.41-33.89-20.91-64.76-30.07-87.57l.61-1.34c9.18,22.85,20.57,54.51,31,88.44C276.22,372.84,277.5,376.71,278.82,380.47Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#444053"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M446.34,537c-.3,0-30.76-5.12-66.64-26.79A232.63,232.63,0,0,1,323.78,463c-20-23.24-36.55-53.92-47.52-85l1.81.34c24.63,69.86,69.87,110.21,102.65,130,35.55,21.49,65.66,26.52,66,26.57Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#444053"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 637.72,
    cy: 818.54,
    rx: 336.35,
    ry: 12.94,
    fill: "#c9bb60",
    opacity: 0.1
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M779.2,831v7.81H547.94v-6.35A76,76,0,0,0,553.17,692H777.62a76.15,76.15,0,0,0-42,50.39A76.16,76.16,0,0,0,779.2,831Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c8cad7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M777.62,692a76.15,76.15,0,0,0-42,50.39H595.19a76.14,76.14,0,0,0-42-50.39Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M283.13,652.2v43.9c0,24.24,17.75,43.9,39.63,43.9h680.39c21.89,0,39.63-19.66,39.63-43.9V652.2Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c8cad7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M779.2,831v7.81H547.94v-6.35a76.11,76.11,0,0,0,17.84-9.5H765A75.8,75.8,0,0,0,779.2,831Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 358.56,
    y: 795.38,
    width: 384.09,
    height: 23.17,
    rx: 9.5,
    ry: 9.5,
    fill: "#c8cad7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.78,171.18a39.63,39.63,0,0,0-39.63-39.63H322.76a39.63,39.63,0,0,0-39.63,39.63V660.74h759.65Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#474157"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.05,188.85V609.52A19.5,19.5,0,0,1,1002.54,629H323.37a19.5,19.5,0,0,1-19.51-19.51V188.85a19.51,19.51,0,0,1,19.51-19.51h679.17A19.51,19.51,0,0,1,1022.05,188.85Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#4c4c78"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 120.48,
    r: 9.15,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 667.96,
    r: 22.56,
    fill: "#fff"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.05,188.86H303.86a19.5,19.5,0,0,1,19.51-19.51h679.17A19.5,19.5,0,0,1,1022.05,188.86Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c8cad7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.41,
    cy: 149.13,
    r: 4.88,
    fill: "#ededf4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.04,
    cy: 149.13,
    r: 4.88,
    fill: "#ededf4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.67,
    cy: 149.13,
    r: 4.88,
    fill: "#ededf4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M621.6,221.23",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M621.6,226.94",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.14,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.84,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.54,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.25,
    cy: 202.67,
    r: 1.43,
    fill: "#c9bb60"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M720,234.07",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M725.7,234.07",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M731.41,234.07",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M737.11,234.07",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M742.82,234.07",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M748.52,234.07",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M754.23,234.07",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M759.93,234.07",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M765.63,234.07",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M771.34,234.07",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M777,234.07",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.95,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.66,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.36,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M621.6,238.35",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M680.07,239.77",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M685.77,239.77",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M691.48,239.77",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M708.59,239.77",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M714.3,239.77",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 208.38,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.14,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.84,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.54,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.25,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.95,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M621.6,244.05",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 214.08,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.14,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.84,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.54,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.25,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.95,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M621.6,249.76",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 219.78,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.14,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.84,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.54,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.25,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.95,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 225.49,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.14,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.84,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.54,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.25,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.95,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 231.19,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.14,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.84,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.54,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.25,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.95,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 236.9,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.14,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.84,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.54,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 242.6,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.56,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.26,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle282 || (_circle282 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.97,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle283 || (_circle283 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle284 || (_circle284 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle285 || (_circle285 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle286 || (_circle286 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle287 || (_circle287 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle288 || (_circle288 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle289 || (_circle289 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle290 || (_circle290 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle291 || (_circle291 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle292 || (_circle292 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle293 || (_circle293 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle294 || (_circle294 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle295 || (_circle295 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle296 || (_circle296 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle297 || (_circle297 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle298 || (_circle298 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle299 || (_circle299 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle300 || (_circle300 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle301 || (_circle301 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle302 || (_circle302 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle303 || (_circle303 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle304 || (_circle304 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle305 || (_circle305 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.14,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle306 || (_circle306 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.84,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle307 || (_circle307 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.54,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle308 || (_circle308 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.25,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle309 || (_circle309 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle310 || (_circle310 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle311 || (_circle311 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle312 || (_circle312 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle313 || (_circle313 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle314 || (_circle314 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle315 || (_circle315 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle316 || (_circle316 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle317 || (_circle317 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle318 || (_circle318 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle319 || (_circle319 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle320 || (_circle320 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle321 || (_circle321 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle322 || (_circle322 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle323 || (_circle323 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle324 || (_circle324 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle325 || (_circle325 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle326 || (_circle326 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle327 || (_circle327 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle328 || (_circle328 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle329 || (_circle329 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle330 || (_circle330 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle331 || (_circle331 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle332 || (_circle332 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle333 || (_circle333 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle334 || (_circle334 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle335 || (_circle335 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle336 || (_circle336 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle337 || (_circle337 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle338 || (_circle338 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle339 || (_circle339 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.8,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle340 || (_circle340 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.5,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle341 || (_circle341 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.2,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle342 || (_circle342 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.43,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle343 || (_circle343 = /*#__PURE__*/React.createElement("circle", {
    cx: 875.13,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle344 || (_circle344 = /*#__PURE__*/React.createElement("circle", {
    cx: 880.84,
    cy: 248.31,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle345 || (_circle345 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.15,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle346 || (_circle346 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.86,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle347 || (_circle347 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.56,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle348 || (_circle348 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.26,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle349 || (_circle349 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.97,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle350 || (_circle350 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.67,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle351 || (_circle351 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.38,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle352 || (_circle352 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.08,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle353 || (_circle353 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.78,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle354 || (_circle354 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.49,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle355 || (_circle355 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.19,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle356 || (_circle356 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.9,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle357 || (_circle357 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.6,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle358 || (_circle358 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle359 || (_circle359 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle360 || (_circle360 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle361 || (_circle361 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle362 || (_circle362 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle363 || (_circle363 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle364 || (_circle364 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle365 || (_circle365 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle366 || (_circle366 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle367 || (_circle367 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle368 || (_circle368 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle369 || (_circle369 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle370 || (_circle370 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle371 || (_circle371 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle372 || (_circle372 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle373 || (_circle373 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle374 || (_circle374 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle375 || (_circle375 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle376 || (_circle376 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle377 || (_circle377 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.14,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle378 || (_circle378 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.84,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle379 || (_circle379 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.54,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle380 || (_circle380 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle381 || (_circle381 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle382 || (_circle382 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle383 || (_circle383 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle384 || (_circle384 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle385 || (_circle385 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle386 || (_circle386 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle387 || (_circle387 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle388 || (_circle388 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle389 || (_circle389 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle390 || (_circle390 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle391 || (_circle391 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle392 || (_circle392 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle393 || (_circle393 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle394 || (_circle394 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle395 || (_circle395 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle396 || (_circle396 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle397 || (_circle397 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle398 || (_circle398 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle399 || (_circle399 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle400 || (_circle400 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle401 || (_circle401 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle402 || (_circle402 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle403 || (_circle403 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle404 || (_circle404 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle405 || (_circle405 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle406 || (_circle406 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle407 || (_circle407 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle408 || (_circle408 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle409 || (_circle409 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle410 || (_circle410 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle411 || (_circle411 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle412 || (_circle412 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle413 || (_circle413 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle414 || (_circle414 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle415 || (_circle415 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle416 || (_circle416 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.8,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle417 || (_circle417 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.5,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle418 || (_circle418 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.2,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle419 || (_circle419 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.91,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle420 || (_circle420 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.61,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle421 || (_circle421 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.32,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle422 || (_circle422 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.02,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle423 || (_circle423 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.73,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle424 || (_circle424 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.43,
    cy: 254.01,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle425 || (_circle425 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.15,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle426 || (_circle426 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.86,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle427 || (_circle427 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.56,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle428 || (_circle428 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.26,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle429 || (_circle429 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.97,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle430 || (_circle430 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.67,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle431 || (_circle431 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.38,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle432 || (_circle432 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.08,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle433 || (_circle433 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.78,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle434 || (_circle434 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.49,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle435 || (_circle435 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.19,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle436 || (_circle436 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.9,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle437 || (_circle437 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.6,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle438 || (_circle438 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle439 || (_circle439 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle440 || (_circle440 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle441 || (_circle441 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle442 || (_circle442 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle443 || (_circle443 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle444 || (_circle444 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle445 || (_circle445 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle446 || (_circle446 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle447 || (_circle447 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle448 || (_circle448 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle449 || (_circle449 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle450 || (_circle450 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle451 || (_circle451 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle452 || (_circle452 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle453 || (_circle453 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle454 || (_circle454 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle455 || (_circle455 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle456 || (_circle456 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle457 || (_circle457 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle458 || (_circle458 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle459 || (_circle459 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle460 || (_circle460 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle461 || (_circle461 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle462 || (_circle462 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle463 || (_circle463 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle464 || (_circle464 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle465 || (_circle465 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle466 || (_circle466 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle467 || (_circle467 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle468 || (_circle468 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle469 || (_circle469 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle470 || (_circle470 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle471 || (_circle471 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle472 || (_circle472 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle473 || (_circle473 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle474 || (_circle474 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle475 || (_circle475 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle476 || (_circle476 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle477 || (_circle477 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle478 || (_circle478 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle479 || (_circle479 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle480 || (_circle480 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle481 || (_circle481 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle482 || (_circle482 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle483 || (_circle483 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle484 || (_circle484 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle485 || (_circle485 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle486 || (_circle486 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle487 || (_circle487 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle488 || (_circle488 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle489 || (_circle489 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle490 || (_circle490 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle491 || (_circle491 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle492 || (_circle492 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle493 || (_circle493 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle494 || (_circle494 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle495 || (_circle495 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle496 || (_circle496 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle497 || (_circle497 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle498 || (_circle498 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle499 || (_circle499 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle500 || (_circle500 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle501 || (_circle501 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle502 || (_circle502 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle503 || (_circle503 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle504 || (_circle504 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle505 || (_circle505 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.8,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle506 || (_circle506 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.5,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle507 || (_circle507 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.2,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle508 || (_circle508 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.91,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle509 || (_circle509 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.61,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle510 || (_circle510 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.32,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle511 || (_circle511 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.02,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle512 || (_circle512 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.73,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle513 || (_circle513 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.43,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle514 || (_circle514 = /*#__PURE__*/React.createElement("circle", {
    cx: 875.13,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle515 || (_circle515 = /*#__PURE__*/React.createElement("circle", {
    cx: 880.84,
    cy: 259.71,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle516 || (_circle516 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.45,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle517 || (_circle517 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.15,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle518 || (_circle518 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.86,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle519 || (_circle519 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.56,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle520 || (_circle520 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.26,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle521 || (_circle521 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.97,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle522 || (_circle522 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.67,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle523 || (_circle523 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.38,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle524 || (_circle524 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.08,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle525 || (_circle525 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.78,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle526 || (_circle526 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.49,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle527 || (_circle527 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.19,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle528 || (_circle528 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.9,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle529 || (_circle529 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.6,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle530 || (_circle530 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle531 || (_circle531 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle532 || (_circle532 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle533 || (_circle533 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle534 || (_circle534 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle535 || (_circle535 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle536 || (_circle536 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle537 || (_circle537 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle538 || (_circle538 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle539 || (_circle539 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle540 || (_circle540 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle541 || (_circle541 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle542 || (_circle542 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle543 || (_circle543 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle544 || (_circle544 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle545 || (_circle545 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle546 || (_circle546 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle547 || (_circle547 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle548 || (_circle548 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle549 || (_circle549 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle550 || (_circle550 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle551 || (_circle551 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle552 || (_circle552 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle553 || (_circle553 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle554 || (_circle554 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle555 || (_circle555 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.25,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle556 || (_circle556 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.95,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle557 || (_circle557 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.66,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle558 || (_circle558 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.36,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle559 || (_circle559 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle560 || (_circle560 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle561 || (_circle561 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle562 || (_circle562 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle563 || (_circle563 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle564 || (_circle564 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle565 || (_circle565 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle566 || (_circle566 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle567 || (_circle567 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle568 || (_circle568 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle569 || (_circle569 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle570 || (_circle570 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle571 || (_circle571 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle572 || (_circle572 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle573 || (_circle573 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle574 || (_circle574 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle575 || (_circle575 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle576 || (_circle576 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle577 || (_circle577 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle578 || (_circle578 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle579 || (_circle579 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle580 || (_circle580 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle581 || (_circle581 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle582 || (_circle582 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle583 || (_circle583 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle584 || (_circle584 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle585 || (_circle585 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle586 || (_circle586 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle587 || (_circle587 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle588 || (_circle588 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle589 || (_circle589 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle590 || (_circle590 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle591 || (_circle591 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle592 || (_circle592 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle593 || (_circle593 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle594 || (_circle594 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle595 || (_circle595 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle596 || (_circle596 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle597 || (_circle597 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle598 || (_circle598 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle599 || (_circle599 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle600 || (_circle600 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle601 || (_circle601 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle602 || (_circle602 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle603 || (_circle603 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.8,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle604 || (_circle604 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.5,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle605 || (_circle605 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.2,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle606 || (_circle606 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.91,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle607 || (_circle607 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.61,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle608 || (_circle608 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.32,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle609 || (_circle609 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.02,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle610 || (_circle610 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.73,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle611 || (_circle611 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.43,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle612 || (_circle612 = /*#__PURE__*/React.createElement("circle", {
    cx: 886.54,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle613 || (_circle613 = /*#__PURE__*/React.createElement("circle", {
    cx: 892.25,
    cy: 265.42,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle614 || (_circle614 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.74,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle615 || (_circle615 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.56,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle616 || (_circle616 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.26,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle617 || (_circle617 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.97,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle618 || (_circle618 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.67,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle619 || (_circle619 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.38,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle620 || (_circle620 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.08,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle621 || (_circle621 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.78,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle622 || (_circle622 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.49,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle623 || (_circle623 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.19,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle624 || (_circle624 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.9,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle625 || (_circle625 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.6,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle626 || (_circle626 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle627 || (_circle627 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle628 || (_circle628 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle629 || (_circle629 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle630 || (_circle630 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle631 || (_circle631 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle632 || (_circle632 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle633 || (_circle633 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle634 || (_circle634 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle635 || (_circle635 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle636 || (_circle636 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle637 || (_circle637 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle638 || (_circle638 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle639 || (_circle639 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle640 || (_circle640 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle641 || (_circle641 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle642 || (_circle642 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle643 || (_circle643 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle644 || (_circle644 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle645 || (_circle645 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle646 || (_circle646 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle647 || (_circle647 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.95,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle648 || (_circle648 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.66,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle649 || (_circle649 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle650 || (_circle650 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle651 || (_circle651 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle652 || (_circle652 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle653 || (_circle653 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle654 || (_circle654 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle655 || (_circle655 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle656 || (_circle656 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle657 || (_circle657 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle658 || (_circle658 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle659 || (_circle659 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle660 || (_circle660 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle661 || (_circle661 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle662 || (_circle662 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle663 || (_circle663 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle664 || (_circle664 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle665 || (_circle665 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle666 || (_circle666 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle667 || (_circle667 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle668 || (_circle668 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle669 || (_circle669 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle670 || (_circle670 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle671 || (_circle671 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle672 || (_circle672 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle673 || (_circle673 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle674 || (_circle674 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle675 || (_circle675 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle676 || (_circle676 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle677 || (_circle677 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle678 || (_circle678 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle679 || (_circle679 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle680 || (_circle680 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle681 || (_circle681 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle682 || (_circle682 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle683 || (_circle683 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle684 || (_circle684 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle685 || (_circle685 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle686 || (_circle686 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle687 || (_circle687 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle688 || (_circle688 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle689 || (_circle689 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle690 || (_circle690 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle691 || (_circle691 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle692 || (_circle692 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle693 || (_circle693 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle694 || (_circle694 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle695 || (_circle695 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.8,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle696 || (_circle696 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.5,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle697 || (_circle697 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.2,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle698 || (_circle698 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.91,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle699 || (_circle699 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.61,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle700 || (_circle700 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.32,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle701 || (_circle701 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.02,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle702 || (_circle702 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.73,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle703 || (_circle703 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.43,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle704 || (_circle704 = /*#__PURE__*/React.createElement("circle", {
    cx: 886.54,
    cy: 271.12,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle705 || (_circle705 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.15,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle706 || (_circle706 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.86,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle707 || (_circle707 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.56,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle708 || (_circle708 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.26,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle709 || (_circle709 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.97,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle710 || (_circle710 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.67,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle711 || (_circle711 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.38,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle712 || (_circle712 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.08,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle713 || (_circle713 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.78,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle714 || (_circle714 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.49,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle715 || (_circle715 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.19,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle716 || (_circle716 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.9,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle717 || (_circle717 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.6,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle718 || (_circle718 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle719 || (_circle719 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle720 || (_circle720 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle721 || (_circle721 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle722 || (_circle722 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle723 || (_circle723 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle724 || (_circle724 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle725 || (_circle725 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle726 || (_circle726 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle727 || (_circle727 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle728 || (_circle728 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle729 || (_circle729 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle730 || (_circle730 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle731 || (_circle731 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle732 || (_circle732 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle733 || (_circle733 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle734 || (_circle734 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle735 || (_circle735 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle736 || (_circle736 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle737 || (_circle737 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle738 || (_circle738 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle739 || (_circle739 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle740 || (_circle740 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle741 || (_circle741 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle742 || (_circle742 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle743 || (_circle743 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle744 || (_circle744 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle745 || (_circle745 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle746 || (_circle746 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle747 || (_circle747 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle748 || (_circle748 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle749 || (_circle749 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle750 || (_circle750 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle751 || (_circle751 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle752 || (_circle752 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle753 || (_circle753 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle754 || (_circle754 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle755 || (_circle755 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle756 || (_circle756 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle757 || (_circle757 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle758 || (_circle758 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle759 || (_circle759 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle760 || (_circle760 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle761 || (_circle761 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle762 || (_circle762 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle763 || (_circle763 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle764 || (_circle764 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle765 || (_circle765 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle766 || (_circle766 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle767 || (_circle767 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle768 || (_circle768 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle769 || (_circle769 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle770 || (_circle770 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle771 || (_circle771 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle772 || (_circle772 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle773 || (_circle773 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle774 || (_circle774 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle775 || (_circle775 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle776 || (_circle776 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle777 || (_circle777 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle778 || (_circle778 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle779 || (_circle779 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle780 || (_circle780 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle781 || (_circle781 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle782 || (_circle782 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle783 || (_circle783 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle784 || (_circle784 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.8,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle785 || (_circle785 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.5,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle786 || (_circle786 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.2,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle787 || (_circle787 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.61,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle788 || (_circle788 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.32,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle789 || (_circle789 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.02,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle790 || (_circle790 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.73,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle791 || (_circle791 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.43,
    cy: 276.83,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle792 || (_circle792 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.45,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle793 || (_circle793 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.15,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle794 || (_circle794 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.86,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle795 || (_circle795 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.56,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle796 || (_circle796 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.26,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle797 || (_circle797 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.67,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle798 || (_circle798 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.08,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle799 || (_circle799 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.78,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle800 || (_circle800 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.49,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle801 || (_circle801 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.19,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle802 || (_circle802 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.9,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle803 || (_circle803 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.6,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle804 || (_circle804 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle805 || (_circle805 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle806 || (_circle806 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle807 || (_circle807 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle808 || (_circle808 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle809 || (_circle809 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle810 || (_circle810 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle811 || (_circle811 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle812 || (_circle812 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle813 || (_circle813 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle814 || (_circle814 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle815 || (_circle815 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle816 || (_circle816 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle817 || (_circle817 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle818 || (_circle818 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle819 || (_circle819 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle820 || (_circle820 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle821 || (_circle821 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle822 || (_circle822 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle823 || (_circle823 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle824 || (_circle824 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle825 || (_circle825 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle826 || (_circle826 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle827 || (_circle827 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle828 || (_circle828 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle829 || (_circle829 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle830 || (_circle830 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle831 || (_circle831 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle832 || (_circle832 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle833 || (_circle833 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle834 || (_circle834 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle835 || (_circle835 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle836 || (_circle836 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle837 || (_circle837 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle838 || (_circle838 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle839 || (_circle839 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle840 || (_circle840 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle841 || (_circle841 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle842 || (_circle842 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle843 || (_circle843 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle844 || (_circle844 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle845 || (_circle845 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle846 || (_circle846 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle847 || (_circle847 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle848 || (_circle848 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle849 || (_circle849 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle850 || (_circle850 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle851 || (_circle851 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle852 || (_circle852 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle853 || (_circle853 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle854 || (_circle854 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle855 || (_circle855 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle856 || (_circle856 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle857 || (_circle857 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle858 || (_circle858 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle859 || (_circle859 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle860 || (_circle860 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle861 || (_circle861 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle862 || (_circle862 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle863 || (_circle863 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle864 || (_circle864 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle865 || (_circle865 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.8,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle866 || (_circle866 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.91,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle867 || (_circle867 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.61,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle868 || (_circle868 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.32,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle869 || (_circle869 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.02,
    cy: 282.53,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle870 || (_circle870 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.26,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle871 || (_circle871 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.97,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle872 || (_circle872 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.19,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle873 || (_circle873 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.9,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle874 || (_circle874 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.6,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle875 || (_circle875 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle876 || (_circle876 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle877 || (_circle877 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle878 || (_circle878 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle879 || (_circle879 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle880 || (_circle880 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle881 || (_circle881 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle882 || (_circle882 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle883 || (_circle883 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle884 || (_circle884 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle885 || (_circle885 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle886 || (_circle886 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle887 || (_circle887 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle888 || (_circle888 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle889 || (_circle889 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle890 || (_circle890 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle891 || (_circle891 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle892 || (_circle892 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle893 || (_circle893 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle894 || (_circle894 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle895 || (_circle895 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle896 || (_circle896 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle897 || (_circle897 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle898 || (_circle898 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle899 || (_circle899 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle900 || (_circle900 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle901 || (_circle901 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle902 || (_circle902 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle903 || (_circle903 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle904 || (_circle904 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle905 || (_circle905 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle906 || (_circle906 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle907 || (_circle907 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle908 || (_circle908 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle909 || (_circle909 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle910 || (_circle910 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle911 || (_circle911 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle912 || (_circle912 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle913 || (_circle913 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle914 || (_circle914 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle915 || (_circle915 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle916 || (_circle916 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle917 || (_circle917 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle918 || (_circle918 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle919 || (_circle919 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle920 || (_circle920 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle921 || (_circle921 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle922 || (_circle922 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle923 || (_circle923 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle924 || (_circle924 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle925 || (_circle925 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle926 || (_circle926 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle927 || (_circle927 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle928 || (_circle928 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle929 || (_circle929 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle930 || (_circle930 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle931 || (_circle931 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle932 || (_circle932 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle933 || (_circle933 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle934 || (_circle934 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle935 || (_circle935 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle936 || (_circle936 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.2,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle937 || (_circle937 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.91,
    cy: 288.23,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle938 || (_circle938 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.86,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle939 || (_circle939 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.56,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle940 || (_circle940 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.26,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle941 || (_circle941 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.9,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle942 || (_circle942 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.6,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle943 || (_circle943 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle944 || (_circle944 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle945 || (_circle945 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle946 || (_circle946 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle947 || (_circle947 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle948 || (_circle948 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle949 || (_circle949 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle950 || (_circle950 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle951 || (_circle951 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle952 || (_circle952 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle953 || (_circle953 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle954 || (_circle954 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle955 || (_circle955 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle956 || (_circle956 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle957 || (_circle957 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle958 || (_circle958 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle959 || (_circle959 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle960 || (_circle960 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle961 || (_circle961 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle962 || (_circle962 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle963 || (_circle963 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle964 || (_circle964 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle965 || (_circle965 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle966 || (_circle966 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle967 || (_circle967 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle968 || (_circle968 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle969 || (_circle969 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle970 || (_circle970 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle971 || (_circle971 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle972 || (_circle972 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle973 || (_circle973 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle974 || (_circle974 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle975 || (_circle975 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle976 || (_circle976 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle977 || (_circle977 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle978 || (_circle978 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle979 || (_circle979 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle980 || (_circle980 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle981 || (_circle981 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle982 || (_circle982 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle983 || (_circle983 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle984 || (_circle984 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle985 || (_circle985 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle986 || (_circle986 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle987 || (_circle987 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle988 || (_circle988 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle989 || (_circle989 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle990 || (_circle990 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle991 || (_circle991 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle992 || (_circle992 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle993 || (_circle993 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle994 || (_circle994 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle995 || (_circle995 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle996 || (_circle996 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle997 || (_circle997 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle998 || (_circle998 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle999 || (_circle999 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1000 || (_circle1000 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1001 || (_circle1001 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1002 || (_circle1002 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1003 || (_circle1003 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1004 || (_circle1004 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.5,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1005 || (_circle1005 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.2,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1006 || (_circle1006 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.91,
    cy: 293.94,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1007 || (_circle1007 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.45,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1008 || (_circle1008 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.15,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1009 || (_circle1009 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.9,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1010 || (_circle1010 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.6,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1011 || (_circle1011 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1012 || (_circle1012 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1013 || (_circle1013 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1014 || (_circle1014 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1015 || (_circle1015 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1016 || (_circle1016 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1017 || (_circle1017 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1018 || (_circle1018 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1019 || (_circle1019 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1020 || (_circle1020 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1021 || (_circle1021 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1022 || (_circle1022 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1023 || (_circle1023 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1024 || (_circle1024 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1025 || (_circle1025 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1026 || (_circle1026 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1027 || (_circle1027 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1028 || (_circle1028 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1029 || (_circle1029 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1030 || (_circle1030 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1031 || (_circle1031 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1032 || (_circle1032 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1033 || (_circle1033 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1034 || (_circle1034 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1035 || (_circle1035 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1036 || (_circle1036 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1037 || (_circle1037 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1038 || (_circle1038 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1039 || (_circle1039 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1040 || (_circle1040 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1041 || (_circle1041 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1042 || (_circle1042 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1043 || (_circle1043 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1044 || (_circle1044 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1045 || (_circle1045 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1046 || (_circle1046 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1047 || (_circle1047 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1048 || (_circle1048 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1049 || (_circle1049 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1050 || (_circle1050 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1051 || (_circle1051 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1052 || (_circle1052 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1053 || (_circle1053 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1054 || (_circle1054 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1055 || (_circle1055 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1056 || (_circle1056 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1057 || (_circle1057 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1058 || (_circle1058 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1059 || (_circle1059 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1060 || (_circle1060 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1061 || (_circle1061 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1062 || (_circle1062 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1063 || (_circle1063 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1064 || (_circle1064 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1065 || (_circle1065 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1066 || (_circle1066 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1067 || (_circle1067 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1068 || (_circle1068 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1069 || (_circle1069 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1070 || (_circle1070 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1071 || (_circle1071 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1072 || (_circle1072 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1073 || (_circle1073 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1074 || (_circle1074 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1075 || (_circle1075 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1076 || (_circle1076 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.5,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1077 || (_circle1077 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.2,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1078 || (_circle1078 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.91,
    cy: 299.64,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1079 || (_circle1079 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.45,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1080 || (_circle1080 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.9,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1081 || (_circle1081 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.6,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1082 || (_circle1082 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1083 || (_circle1083 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1084 || (_circle1084 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1085 || (_circle1085 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1086 || (_circle1086 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1087 || (_circle1087 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1088 || (_circle1088 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1089 || (_circle1089 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1090 || (_circle1090 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1091 || (_circle1091 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1092 || (_circle1092 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1093 || (_circle1093 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1094 || (_circle1094 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1095 || (_circle1095 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1096 || (_circle1096 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1097 || (_circle1097 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1098 || (_circle1098 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1099 || (_circle1099 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1100 || (_circle1100 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1101 || (_circle1101 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1102 || (_circle1102 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1103 || (_circle1103 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1104 || (_circle1104 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1105 || (_circle1105 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1106 || (_circle1106 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1107 || (_circle1107 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1108 || (_circle1108 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1109 || (_circle1109 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1110 || (_circle1110 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1111 || (_circle1111 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1112 || (_circle1112 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1113 || (_circle1113 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1114 || (_circle1114 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1115 || (_circle1115 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1116 || (_circle1116 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1117 || (_circle1117 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1118 || (_circle1118 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1119 || (_circle1119 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1120 || (_circle1120 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1121 || (_circle1121 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1122 || (_circle1122 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1123 || (_circle1123 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1124 || (_circle1124 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1125 || (_circle1125 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1126 || (_circle1126 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1127 || (_circle1127 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1128 || (_circle1128 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1129 || (_circle1129 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1130 || (_circle1130 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1131 || (_circle1131 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1132 || (_circle1132 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1133 || (_circle1133 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1134 || (_circle1134 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1135 || (_circle1135 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1136 || (_circle1136 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1137 || (_circle1137 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1138 || (_circle1138 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1139 || (_circle1139 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1140 || (_circle1140 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1141 || (_circle1141 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1142 || (_circle1142 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1143 || (_circle1143 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1144 || (_circle1144 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1145 || (_circle1145 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1146 || (_circle1146 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1147 || (_circle1147 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1148 || (_circle1148 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1149 || (_circle1149 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1150 || (_circle1150 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1151 || (_circle1151 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1152 || (_circle1152 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1153 || (_circle1153 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.5,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1154 || (_circle1154 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.2,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1155 || (_circle1155 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.91,
    cy: 305.35,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1156 || (_circle1156 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1157 || (_circle1157 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1158 || (_circle1158 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1159 || (_circle1159 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1160 || (_circle1160 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1161 || (_circle1161 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1162 || (_circle1162 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1163 || (_circle1163 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1164 || (_circle1164 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1165 || (_circle1165 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1166 || (_circle1166 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1167 || (_circle1167 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1168 || (_circle1168 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1169 || (_circle1169 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1170 || (_circle1170 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1171 || (_circle1171 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1172 || (_circle1172 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1173 || (_circle1173 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1174 || (_circle1174 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1175 || (_circle1175 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1176 || (_circle1176 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1177 || (_circle1177 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1178 || (_circle1178 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1179 || (_circle1179 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1180 || (_circle1180 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1181 || (_circle1181 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1182 || (_circle1182 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1183 || (_circle1183 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1184 || (_circle1184 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1185 || (_circle1185 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1186 || (_circle1186 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1187 || (_circle1187 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1188 || (_circle1188 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1189 || (_circle1189 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1190 || (_circle1190 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1191 || (_circle1191 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1192 || (_circle1192 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1193 || (_circle1193 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1194 || (_circle1194 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1195 || (_circle1195 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1196 || (_circle1196 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1197 || (_circle1197 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1198 || (_circle1198 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1199 || (_circle1199 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1200 || (_circle1200 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1201 || (_circle1201 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1202 || (_circle1202 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1203 || (_circle1203 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1204 || (_circle1204 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1205 || (_circle1205 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1206 || (_circle1206 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1207 || (_circle1207 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1208 || (_circle1208 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1209 || (_circle1209 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1210 || (_circle1210 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1211 || (_circle1211 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1212 || (_circle1212 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1213 || (_circle1213 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1214 || (_circle1214 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1215 || (_circle1215 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1216 || (_circle1216 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1217 || (_circle1217 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1218 || (_circle1218 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1219 || (_circle1219 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1220 || (_circle1220 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1221 || (_circle1221 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1222 || (_circle1222 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1223 || (_circle1223 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1224 || (_circle1224 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1225 || (_circle1225 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 311.05,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1226 || (_circle1226 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1227 || (_circle1227 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1228 || (_circle1228 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1229 || (_circle1229 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1230 || (_circle1230 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1231 || (_circle1231 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1232 || (_circle1232 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1233 || (_circle1233 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1234 || (_circle1234 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1235 || (_circle1235 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1236 || (_circle1236 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1237 || (_circle1237 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1238 || (_circle1238 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1239 || (_circle1239 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1240 || (_circle1240 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1241 || (_circle1241 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1242 || (_circle1242 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1243 || (_circle1243 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1244 || (_circle1244 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1245 || (_circle1245 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1246 || (_circle1246 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1247 || (_circle1247 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1248 || (_circle1248 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1249 || (_circle1249 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1250 || (_circle1250 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1251 || (_circle1251 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1252 || (_circle1252 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1253 || (_circle1253 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1254 || (_circle1254 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1255 || (_circle1255 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1256 || (_circle1256 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1257 || (_circle1257 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1258 || (_circle1258 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1259 || (_circle1259 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1260 || (_circle1260 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1261 || (_circle1261 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1262 || (_circle1262 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1263 || (_circle1263 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1264 || (_circle1264 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1265 || (_circle1265 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1266 || (_circle1266 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1267 || (_circle1267 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1268 || (_circle1268 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1269 || (_circle1269 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1270 || (_circle1270 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1271 || (_circle1271 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1272 || (_circle1272 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1273 || (_circle1273 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1274 || (_circle1274 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1275 || (_circle1275 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1276 || (_circle1276 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1277 || (_circle1277 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1278 || (_circle1278 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1279 || (_circle1279 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1280 || (_circle1280 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1281 || (_circle1281 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1282 || (_circle1282 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1283 || (_circle1283 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1284 || (_circle1284 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1285 || (_circle1285 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1286 || (_circle1286 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1287 || (_circle1287 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1288 || (_circle1288 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1289 || (_circle1289 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1290 || (_circle1290 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1291 || (_circle1291 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1292 || (_circle1292 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1293 || (_circle1293 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1294 || (_circle1294 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1295 || (_circle1295 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1296 || (_circle1296 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 316.76,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1297 || (_circle1297 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1298 || (_circle1298 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1299 || (_circle1299 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1300 || (_circle1300 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1301 || (_circle1301 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1302 || (_circle1302 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1303 || (_circle1303 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1304 || (_circle1304 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1305 || (_circle1305 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1306 || (_circle1306 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1307 || (_circle1307 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1308 || (_circle1308 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1309 || (_circle1309 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1310 || (_circle1310 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1311 || (_circle1311 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1312 || (_circle1312 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1313 || (_circle1313 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1314 || (_circle1314 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1315 || (_circle1315 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1316 || (_circle1316 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1317 || (_circle1317 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1318 || (_circle1318 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1319 || (_circle1319 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1320 || (_circle1320 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1321 || (_circle1321 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1322 || (_circle1322 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1323 || (_circle1323 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1324 || (_circle1324 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1325 || (_circle1325 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1326 || (_circle1326 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1327 || (_circle1327 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1328 || (_circle1328 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1329 || (_circle1329 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1330 || (_circle1330 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1331 || (_circle1331 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1332 || (_circle1332 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1333 || (_circle1333 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1334 || (_circle1334 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1335 || (_circle1335 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1336 || (_circle1336 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1337 || (_circle1337 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1338 || (_circle1338 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1339 || (_circle1339 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1340 || (_circle1340 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1341 || (_circle1341 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1342 || (_circle1342 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1343 || (_circle1343 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1344 || (_circle1344 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1345 || (_circle1345 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1346 || (_circle1346 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1347 || (_circle1347 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1348 || (_circle1348 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1349 || (_circle1349 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1350 || (_circle1350 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1351 || (_circle1351 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1352 || (_circle1352 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1353 || (_circle1353 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1354 || (_circle1354 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1355 || (_circle1355 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1356 || (_circle1356 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1357 || (_circle1357 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1358 || (_circle1358 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1359 || (_circle1359 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1360 || (_circle1360 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1361 || (_circle1361 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1362 || (_circle1362 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1363 || (_circle1363 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 322.46,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1364 || (_circle1364 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1365 || (_circle1365 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1366 || (_circle1366 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1367 || (_circle1367 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1368 || (_circle1368 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1369 || (_circle1369 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1370 || (_circle1370 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1371 || (_circle1371 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1372 || (_circle1372 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1373 || (_circle1373 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1374 || (_circle1374 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1375 || (_circle1375 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1376 || (_circle1376 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1377 || (_circle1377 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1378 || (_circle1378 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1379 || (_circle1379 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1380 || (_circle1380 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1381 || (_circle1381 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1382 || (_circle1382 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1383 || (_circle1383 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1384 || (_circle1384 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1385 || (_circle1385 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1386 || (_circle1386 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1387 || (_circle1387 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1388 || (_circle1388 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1389 || (_circle1389 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1390 || (_circle1390 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1391 || (_circle1391 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1392 || (_circle1392 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1393 || (_circle1393 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1394 || (_circle1394 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1395 || (_circle1395 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1396 || (_circle1396 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1397 || (_circle1397 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1398 || (_circle1398 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1399 || (_circle1399 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1400 || (_circle1400 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1401 || (_circle1401 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1402 || (_circle1402 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1403 || (_circle1403 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1404 || (_circle1404 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1405 || (_circle1405 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1406 || (_circle1406 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1407 || (_circle1407 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1408 || (_circle1408 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1409 || (_circle1409 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1410 || (_circle1410 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1411 || (_circle1411 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1412 || (_circle1412 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1413 || (_circle1413 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1414 || (_circle1414 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1415 || (_circle1415 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1416 || (_circle1416 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1417 || (_circle1417 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1418 || (_circle1418 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1419 || (_circle1419 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1420 || (_circle1420 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1421 || (_circle1421 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1422 || (_circle1422 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1423 || (_circle1423 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1424 || (_circle1424 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1425 || (_circle1425 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1426 || (_circle1426 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1427 || (_circle1427 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1428 || (_circle1428 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1429 || (_circle1429 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 328.16,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1430 || (_circle1430 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1431 || (_circle1431 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1432 || (_circle1432 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1433 || (_circle1433 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1434 || (_circle1434 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1435 || (_circle1435 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1436 || (_circle1436 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1437 || (_circle1437 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1438 || (_circle1438 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1439 || (_circle1439 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1440 || (_circle1440 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1441 || (_circle1441 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1442 || (_circle1442 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1443 || (_circle1443 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1444 || (_circle1444 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1445 || (_circle1445 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1446 || (_circle1446 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1447 || (_circle1447 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1448 || (_circle1448 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1449 || (_circle1449 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1450 || (_circle1450 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1451 || (_circle1451 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1452 || (_circle1452 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1453 || (_circle1453 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1454 || (_circle1454 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1455 || (_circle1455 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1456 || (_circle1456 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1457 || (_circle1457 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1458 || (_circle1458 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1459 || (_circle1459 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1460 || (_circle1460 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1461 || (_circle1461 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1462 || (_circle1462 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1463 || (_circle1463 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1464 || (_circle1464 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1465 || (_circle1465 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1466 || (_circle1466 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1467 || (_circle1467 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1468 || (_circle1468 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1469 || (_circle1469 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1470 || (_circle1470 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1471 || (_circle1471 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1472 || (_circle1472 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1473 || (_circle1473 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1474 || (_circle1474 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1475 || (_circle1475 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1476 || (_circle1476 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1477 || (_circle1477 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1478 || (_circle1478 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1479 || (_circle1479 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1480 || (_circle1480 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1481 || (_circle1481 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1482 || (_circle1482 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1483 || (_circle1483 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1484 || (_circle1484 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1485 || (_circle1485 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1486 || (_circle1486 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1487 || (_circle1487 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1488 || (_circle1488 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1489 || (_circle1489 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1490 || (_circle1490 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 333.87,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1491 || (_circle1491 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1492 || (_circle1492 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1493 || (_circle1493 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1494 || (_circle1494 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1495 || (_circle1495 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1496 || (_circle1496 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1497 || (_circle1497 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1498 || (_circle1498 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1499 || (_circle1499 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1500 || (_circle1500 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1501 || (_circle1501 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1502 || (_circle1502 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1503 || (_circle1503 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1504 || (_circle1504 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1505 || (_circle1505 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1506 || (_circle1506 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1507 || (_circle1507 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1508 || (_circle1508 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1509 || (_circle1509 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1510 || (_circle1510 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1511 || (_circle1511 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1512 || (_circle1512 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1513 || (_circle1513 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1514 || (_circle1514 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1515 || (_circle1515 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1516 || (_circle1516 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1517 || (_circle1517 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1518 || (_circle1518 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1519 || (_circle1519 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1520 || (_circle1520 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1521 || (_circle1521 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1522 || (_circle1522 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1523 || (_circle1523 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1524 || (_circle1524 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1525 || (_circle1525 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1526 || (_circle1526 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1527 || (_circle1527 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1528 || (_circle1528 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1529 || (_circle1529 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1530 || (_circle1530 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1531 || (_circle1531 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1532 || (_circle1532 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1533 || (_circle1533 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1534 || (_circle1534 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1535 || (_circle1535 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1536 || (_circle1536 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1537 || (_circle1537 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1538 || (_circle1538 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1539 || (_circle1539 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1540 || (_circle1540 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1541 || (_circle1541 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1542 || (_circle1542 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1543 || (_circle1543 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1544 || (_circle1544 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 339.57,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1545 || (_circle1545 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1546 || (_circle1546 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1547 || (_circle1547 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1548 || (_circle1548 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1549 || (_circle1549 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1550 || (_circle1550 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1551 || (_circle1551 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1552 || (_circle1552 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1553 || (_circle1553 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1554 || (_circle1554 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1555 || (_circle1555 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1556 || (_circle1556 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1557 || (_circle1557 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1558 || (_circle1558 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1559 || (_circle1559 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1560 || (_circle1560 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1561 || (_circle1561 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1562 || (_circle1562 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1563 || (_circle1563 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1564 || (_circle1564 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1565 || (_circle1565 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1566 || (_circle1566 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1567 || (_circle1567 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1568 || (_circle1568 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1569 || (_circle1569 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1570 || (_circle1570 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1571 || (_circle1571 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1572 || (_circle1572 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1573 || (_circle1573 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1574 || (_circle1574 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1575 || (_circle1575 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1576 || (_circle1576 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1577 || (_circle1577 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1578 || (_circle1578 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1579 || (_circle1579 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1580 || (_circle1580 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1581 || (_circle1581 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1582 || (_circle1582 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1583 || (_circle1583 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1584 || (_circle1584 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1585 || (_circle1585 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1586 || (_circle1586 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1587 || (_circle1587 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1588 || (_circle1588 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1589 || (_circle1589 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1590 || (_circle1590 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1591 || (_circle1591 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1592 || (_circle1592 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1593 || (_circle1593 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1594 || (_circle1594 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1595 || (_circle1595 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1596 || (_circle1596 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1597 || (_circle1597 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1598 || (_circle1598 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1599 || (_circle1599 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 345.28,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1600 || (_circle1600 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.01,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1601 || (_circle1601 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.71,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1602 || (_circle1602 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1603 || (_circle1603 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1604 || (_circle1604 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1605 || (_circle1605 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1606 || (_circle1606 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1607 || (_circle1607 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1608 || (_circle1608 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1609 || (_circle1609 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1610 || (_circle1610 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1611 || (_circle1611 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1612 || (_circle1612 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1613 || (_circle1613 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1614 || (_circle1614 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1615 || (_circle1615 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1616 || (_circle1616 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1617 || (_circle1617 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1618 || (_circle1618 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1619 || (_circle1619 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1620 || (_circle1620 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1621 || (_circle1621 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1622 || (_circle1622 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1623 || (_circle1623 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1624 || (_circle1624 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1625 || (_circle1625 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1626 || (_circle1626 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1627 || (_circle1627 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1628 || (_circle1628 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1629 || (_circle1629 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1630 || (_circle1630 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1631 || (_circle1631 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1632 || (_circle1632 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1633 || (_circle1633 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1634 || (_circle1634 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1635 || (_circle1635 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1636 || (_circle1636 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1637 || (_circle1637 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1638 || (_circle1638 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1639 || (_circle1639 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1640 || (_circle1640 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1641 || (_circle1641 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1642 || (_circle1642 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1643 || (_circle1643 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1644 || (_circle1644 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1645 || (_circle1645 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1646 || (_circle1646 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1647 || (_circle1647 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1648 || (_circle1648 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1649 || (_circle1649 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1650 || (_circle1650 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1651 || (_circle1651 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1652 || (_circle1652 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1653 || (_circle1653 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 350.98,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1654 || (_circle1654 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1655 || (_circle1655 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1656 || (_circle1656 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1657 || (_circle1657 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1658 || (_circle1658 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1659 || (_circle1659 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1660 || (_circle1660 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1661 || (_circle1661 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1662 || (_circle1662 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1663 || (_circle1663 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1664 || (_circle1664 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1665 || (_circle1665 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1666 || (_circle1666 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1667 || (_circle1667 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1668 || (_circle1668 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1669 || (_circle1669 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1670 || (_circle1670 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1671 || (_circle1671 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1672 || (_circle1672 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1673 || (_circle1673 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1674 || (_circle1674 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1675 || (_circle1675 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1676 || (_circle1676 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1677 || (_circle1677 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1678 || (_circle1678 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1679 || (_circle1679 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1680 || (_circle1680 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1681 || (_circle1681 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1682 || (_circle1682 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1683 || (_circle1683 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1684 || (_circle1684 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1685 || (_circle1685 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1686 || (_circle1686 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1687 || (_circle1687 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1688 || (_circle1688 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1689 || (_circle1689 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1690 || (_circle1690 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1691 || (_circle1691 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1692 || (_circle1692 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1693 || (_circle1693 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1694 || (_circle1694 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1695 || (_circle1695 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1696 || (_circle1696 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1697 || (_circle1697 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1698 || (_circle1698 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1699 || (_circle1699 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1700 || (_circle1700 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1701 || (_circle1701 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1702 || (_circle1702 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1703 || (_circle1703 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1704 || (_circle1704 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1705 || (_circle1705 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1706 || (_circle1706 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1707 || (_circle1707 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 356.69,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1708 || (_circle1708 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1709 || (_circle1709 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1710 || (_circle1710 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1711 || (_circle1711 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1712 || (_circle1712 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1713 || (_circle1713 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1714 || (_circle1714 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1715 || (_circle1715 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1716 || (_circle1716 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1717 || (_circle1717 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1718 || (_circle1718 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1719 || (_circle1719 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1720 || (_circle1720 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1721 || (_circle1721 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1722 || (_circle1722 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1723 || (_circle1723 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1724 || (_circle1724 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1725 || (_circle1725 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1726 || (_circle1726 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1727 || (_circle1727 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1728 || (_circle1728 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1729 || (_circle1729 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1730 || (_circle1730 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1731 || (_circle1731 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1732 || (_circle1732 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1733 || (_circle1733 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1734 || (_circle1734 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1735 || (_circle1735 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1736 || (_circle1736 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1737 || (_circle1737 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1738 || (_circle1738 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1739 || (_circle1739 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1740 || (_circle1740 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1741 || (_circle1741 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1742 || (_circle1742 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1743 || (_circle1743 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1744 || (_circle1744 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1745 || (_circle1745 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1746 || (_circle1746 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1747 || (_circle1747 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1748 || (_circle1748 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1749 || (_circle1749 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1750 || (_circle1750 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1751 || (_circle1751 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1752 || (_circle1752 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1753 || (_circle1753 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1754 || (_circle1754 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1755 || (_circle1755 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1756 || (_circle1756 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1757 || (_circle1757 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1758 || (_circle1758 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1759 || (_circle1759 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1760 || (_circle1760 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1761 || (_circle1761 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 362.39,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1762 || (_circle1762 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1763 || (_circle1763 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1764 || (_circle1764 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1765 || (_circle1765 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1766 || (_circle1766 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1767 || (_circle1767 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1768 || (_circle1768 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1769 || (_circle1769 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.07,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1770 || (_circle1770 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1771 || (_circle1771 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1772 || (_circle1772 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1773 || (_circle1773 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1774 || (_circle1774 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1775 || (_circle1775 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1776 || (_circle1776 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1777 || (_circle1777 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1778 || (_circle1778 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1779 || (_circle1779 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1780 || (_circle1780 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1781 || (_circle1781 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1782 || (_circle1782 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1783 || (_circle1783 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1784 || (_circle1784 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1785 || (_circle1785 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1786 || (_circle1786 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1787 || (_circle1787 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1788 || (_circle1788 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1789 || (_circle1789 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1790 || (_circle1790 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1791 || (_circle1791 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1792 || (_circle1792 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1793 || (_circle1793 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1794 || (_circle1794 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1795 || (_circle1795 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1796 || (_circle1796 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1797 || (_circle1797 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1798 || (_circle1798 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1799 || (_circle1799 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1800 || (_circle1800 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1801 || (_circle1801 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1802 || (_circle1802 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1803 || (_circle1803 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1804 || (_circle1804 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1805 || (_circle1805 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1806 || (_circle1806 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1807 || (_circle1807 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1808 || (_circle1808 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1809 || (_circle1809 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 368.09,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1810 || (_circle1810 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.12,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1811 || (_circle1811 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.53,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1812 || (_circle1812 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1813 || (_circle1813 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1814 || (_circle1814 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1815 || (_circle1815 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1816 || (_circle1816 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1817 || (_circle1817 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.36,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1818 || (_circle1818 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.07,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1819 || (_circle1819 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1820 || (_circle1820 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1821 || (_circle1821 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1822 || (_circle1822 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1823 || (_circle1823 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1824 || (_circle1824 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1825 || (_circle1825 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1826 || (_circle1826 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1827 || (_circle1827 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1828 || (_circle1828 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1829 || (_circle1829 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1830 || (_circle1830 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1831 || (_circle1831 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1832 || (_circle1832 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1833 || (_circle1833 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1834 || (_circle1834 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1835 || (_circle1835 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1836 || (_circle1836 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1837 || (_circle1837 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1838 || (_circle1838 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.97,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1839 || (_circle1839 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.67,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1840 || (_circle1840 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.37,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1841 || (_circle1841 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1842 || (_circle1842 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1843 || (_circle1843 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1844 || (_circle1844 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1845 || (_circle1845 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1846 || (_circle1846 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1847 || (_circle1847 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1848 || (_circle1848 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1849 || (_circle1849 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1850 || (_circle1850 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1851 || (_circle1851 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1852 || (_circle1852 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1853 || (_circle1853 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1854 || (_circle1854 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1855 || (_circle1855 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1856 || (_circle1856 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1857 || (_circle1857 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 373.8,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1858 || (_circle1858 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.83,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1859 || (_circle1859 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1860 || (_circle1860 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1861 || (_circle1861 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1862 || (_circle1862 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1863 || (_circle1863 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1864 || (_circle1864 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1865 || (_circle1865 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1866 || (_circle1866 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.36,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1867 || (_circle1867 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.07,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1868 || (_circle1868 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1869 || (_circle1869 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1870 || (_circle1870 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1871 || (_circle1871 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1872 || (_circle1872 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1873 || (_circle1873 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1874 || (_circle1874 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1875 || (_circle1875 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1876 || (_circle1876 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1877 || (_circle1877 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1878 || (_circle1878 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1879 || (_circle1879 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1880 || (_circle1880 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1881 || (_circle1881 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1882 || (_circle1882 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1883 || (_circle1883 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1884 || (_circle1884 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1885 || (_circle1885 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1886 || (_circle1886 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1887 || (_circle1887 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1888 || (_circle1888 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1889 || (_circle1889 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.08,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1890 || (_circle1890 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1891 || (_circle1891 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1892 || (_circle1892 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1893 || (_circle1893 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1894 || (_circle1894 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1895 || (_circle1895 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.3,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1896 || (_circle1896 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1897 || (_circle1897 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1898 || (_circle1898 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1899 || (_circle1899 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1900 || (_circle1900 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1901 || (_circle1901 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1902 || (_circle1902 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1903 || (_circle1903 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1904 || (_circle1904 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 379.5,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1905 || (_circle1905 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1906 || (_circle1906 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1907 || (_circle1907 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1908 || (_circle1908 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1909 || (_circle1909 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1910 || (_circle1910 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1911 || (_circle1911 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.36,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1912 || (_circle1912 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.07,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1913 || (_circle1913 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1914 || (_circle1914 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1915 || (_circle1915 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1916 || (_circle1916 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1917 || (_circle1917 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1918 || (_circle1918 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1919 || (_circle1919 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1920 || (_circle1920 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1921 || (_circle1921 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1922 || (_circle1922 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1923 || (_circle1923 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1924 || (_circle1924 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1925 || (_circle1925 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1926 || (_circle1926 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1927 || (_circle1927 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1928 || (_circle1928 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1929 || (_circle1929 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1930 || (_circle1930 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1931 || (_circle1931 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1932 || (_circle1932 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1933 || (_circle1933 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.26,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1934 || (_circle1934 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1935 || (_circle1935 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1936 || (_circle1936 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1937 || (_circle1937 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1938 || (_circle1938 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.6,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1939 || (_circle1939 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1940 || (_circle1940 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1941 || (_circle1941 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1942 || (_circle1942 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1943 || (_circle1943 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 385.21,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1944 || (_circle1944 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.94,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1945 || (_circle1945 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.64,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1946 || (_circle1946 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.35,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1947 || (_circle1947 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1948 || (_circle1948 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1949 || (_circle1949 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1950 || (_circle1950 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1951 || (_circle1951 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1952 || (_circle1952 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1953 || (_circle1953 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.36,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1954 || (_circle1954 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.07,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1955 || (_circle1955 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1956 || (_circle1956 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1957 || (_circle1957 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1958 || (_circle1958 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1959 || (_circle1959 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1960 || (_circle1960 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1961 || (_circle1961 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1962 || (_circle1962 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1963 || (_circle1963 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1964 || (_circle1964 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1965 || (_circle1965 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1966 || (_circle1966 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1967 || (_circle1967 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1968 || (_circle1968 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1969 || (_circle1969 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1970 || (_circle1970 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1971 || (_circle1971 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1972 || (_circle1972 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1973 || (_circle1973 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1974 || (_circle1974 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.85,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1975 || (_circle1975 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.56,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1976 || (_circle1976 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.78,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1977 || (_circle1977 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1978 || (_circle1978 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1979 || (_circle1979 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1980 || (_circle1980 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.71,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1981 || (_circle1981 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1982 || (_circle1982 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1983 || (_circle1983 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1984 || (_circle1984 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1985 || (_circle1985 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 390.91,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1986 || (_circle1986 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.05,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1987 || (_circle1987 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.76,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1988 || (_circle1988 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1989 || (_circle1989 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1990 || (_circle1990 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1991 || (_circle1991 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.66,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1992 || (_circle1992 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.36,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1993 || (_circle1993 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.07,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1994 || (_circle1994 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1995 || (_circle1995 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1996 || (_circle1996 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1997 || (_circle1997 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1998 || (_circle1998 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle1999 || (_circle1999 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2000 || (_circle2000 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2001 || (_circle2001 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2002 || (_circle2002 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2003 || (_circle2003 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2004 || (_circle2004 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2005 || (_circle2005 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2006 || (_circle2006 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2007 || (_circle2007 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2008 || (_circle2008 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2009 || (_circle2009 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2010 || (_circle2010 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2011 || (_circle2011 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2012 || (_circle2012 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2013 || (_circle2013 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2014 || (_circle2014 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2015 || (_circle2015 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2016 || (_circle2016 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2017 || (_circle2017 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2018 || (_circle2018 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2019 || (_circle2019 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 396.61,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2020 || (_circle2020 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2021 || (_circle2021 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2022 || (_circle2022 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2023 || (_circle2023 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2024 || (_circle2024 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.36,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2025 || (_circle2025 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.07,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2026 || (_circle2026 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2027 || (_circle2027 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2028 || (_circle2028 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2029 || (_circle2029 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2030 || (_circle2030 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2031 || (_circle2031 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2032 || (_circle2032 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2033 || (_circle2033 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2034 || (_circle2034 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2035 || (_circle2035 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2036 || (_circle2036 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2037 || (_circle2037 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2038 || (_circle2038 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2039 || (_circle2039 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2040 || (_circle2040 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2041 || (_circle2041 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2042 || (_circle2042 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2043 || (_circle2043 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2044 || (_circle2044 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2045 || (_circle2045 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2046 || (_circle2046 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2047 || (_circle2047 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2048 || (_circle2048 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2049 || (_circle2049 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 402.32,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2050 || (_circle2050 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.46,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2051 || (_circle2051 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.16,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2052 || (_circle2052 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2053 || (_circle2053 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2054 || (_circle2054 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2055 || (_circle2055 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2056 || (_circle2056 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2057 || (_circle2057 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2058 || (_circle2058 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2059 || (_circle2059 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.36,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2060 || (_circle2060 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.07,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2061 || (_circle2061 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2062 || (_circle2062 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2063 || (_circle2063 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2064 || (_circle2064 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2065 || (_circle2065 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2066 || (_circle2066 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2067 || (_circle2067 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2068 || (_circle2068 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2069 || (_circle2069 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2070 || (_circle2070 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2071 || (_circle2071 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2072 || (_circle2072 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2073 || (_circle2073 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2074 || (_circle2074 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2075 || (_circle2075 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2076 || (_circle2076 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2077 || (_circle2077 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2078 || (_circle2078 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2079 || (_circle2079 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2080 || (_circle2080 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2081 || (_circle2081 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.49,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2082 || (_circle2082 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M829.81,438",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _circle2083 || (_circle2083 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2084 || (_circle2084 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2085 || (_circle2085 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 408.02,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2086 || (_circle2086 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2087 || (_circle2087 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2088 || (_circle2088 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2089 || (_circle2089 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2090 || (_circle2090 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2091 || (_circle2091 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2092 || (_circle2092 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2093 || (_circle2093 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2094 || (_circle2094 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.07,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2095 || (_circle2095 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2096 || (_circle2096 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2097 || (_circle2097 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2098 || (_circle2098 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.88,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2099 || (_circle2099 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.59,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2100 || (_circle2100 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2101 || (_circle2101 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2102 || (_circle2102 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2103 || (_circle2103 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2104 || (_circle2104 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2105 || (_circle2105 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2106 || (_circle2106 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2107 || (_circle2107 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2108 || (_circle2108 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2109 || (_circle2109 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2110 || (_circle2110 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2111 || (_circle2111 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2112 || (_circle2112 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2113 || (_circle2113 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2114 || (_circle2114 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2115 || (_circle2115 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.19,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2116 || (_circle2116 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2117 || (_circle2117 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 413.73,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2118 || (_circle2118 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2119 || (_circle2119 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2120 || (_circle2120 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2121 || (_circle2121 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2122 || (_circle2122 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2123 || (_circle2123 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2124 || (_circle2124 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2125 || (_circle2125 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2126 || (_circle2126 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2127 || (_circle2127 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2128 || (_circle2128 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.47,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2129 || (_circle2129 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.18,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2130 || (_circle2130 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.29,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2131 || (_circle2131 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2132 || (_circle2132 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2133 || (_circle2133 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2134 || (_circle2134 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2135 || (_circle2135 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2136 || (_circle2136 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2137 || (_circle2137 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2138 || (_circle2138 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2139 || (_circle2139 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2140 || (_circle2140 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2141 || (_circle2141 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2142 || (_circle2142 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2143 || (_circle2143 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2144 || (_circle2144 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2145 || (_circle2145 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2146 || (_circle2146 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2147 || (_circle2147 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 419.43,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2148 || (_circle2148 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2149 || (_circle2149 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2150 || (_circle2150 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2151 || (_circle2151 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2152 || (_circle2152 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2153 || (_circle2153 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2154 || (_circle2154 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2155 || (_circle2155 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2156 || (_circle2156 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2157 || (_circle2157 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2158 || (_circle2158 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2159 || (_circle2159 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2160 || (_circle2160 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2161 || (_circle2161 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2162 || (_circle2162 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2163 || (_circle2163 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2164 || (_circle2164 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2165 || (_circle2165 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2166 || (_circle2166 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2167 || (_circle2167 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2168 || (_circle2168 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2169 || (_circle2169 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2170 || (_circle2170 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.42,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2171 || (_circle2171 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2172 || (_circle2172 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2173 || (_circle2173 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2174 || (_circle2174 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2175 || (_circle2175 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 425.14,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2176 || (_circle2176 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2177 || (_circle2177 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2178 || (_circle2178 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2179 || (_circle2179 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2180 || (_circle2180 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2181 || (_circle2181 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2182 || (_circle2182 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2183 || (_circle2183 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2184 || (_circle2184 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2185 || (_circle2185 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2186 || (_circle2186 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2187 || (_circle2187 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2188 || (_circle2188 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2189 || (_circle2189 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2190 || (_circle2190 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2191 || (_circle2191 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2192 || (_circle2192 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2193 || (_circle2193 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2194 || (_circle2194 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2195 || (_circle2195 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2196 || (_circle2196 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2197 || (_circle2197 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2198 || (_circle2198 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.74,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2199 || (_circle2199 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2200 || (_circle2200 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2201 || (_circle2201 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2202 || (_circle2202 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2203 || (_circle2203 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2204 || (_circle2204 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2205 || (_circle2205 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 430.84,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2206 || (_circle2206 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2207 || (_circle2207 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2208 || (_circle2208 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2209 || (_circle2209 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2210 || (_circle2210 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2211 || (_circle2211 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2212 || (_circle2212 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2213 || (_circle2213 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2214 || (_circle2214 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2215 || (_circle2215 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2216 || (_circle2216 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2217 || (_circle2217 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2218 || (_circle2218 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2219 || (_circle2219 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2220 || (_circle2220 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2221 || (_circle2221 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.99,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2222 || (_circle2222 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2223 || (_circle2223 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2224 || (_circle2224 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2225 || (_circle2225 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2226 || (_circle2226 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2227 || (_circle2227 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2228 || (_circle2228 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2229 || (_circle2229 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2230 || (_circle2230 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2231 || (_circle2231 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2232 || (_circle2232 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.12,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2233 || (_circle2233 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.82,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2234 || (_circle2234 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2235 || (_circle2235 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2236 || (_circle2236 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2237 || (_circle2237 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2238 || (_circle2238 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2239 || (_circle2239 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2240 || (_circle2240 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 436.54,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2241 || (_circle2241 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2242 || (_circle2242 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2243 || (_circle2243 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2244 || (_circle2244 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2245 || (_circle2245 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2246 || (_circle2246 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2247 || (_circle2247 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2248 || (_circle2248 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2249 || (_circle2249 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2250 || (_circle2250 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2251 || (_circle2251 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2252 || (_circle2252 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2253 || (_circle2253 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2254 || (_circle2254 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2255 || (_circle2255 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2256 || (_circle2256 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2257 || (_circle2257 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2258 || (_circle2258 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2259 || (_circle2259 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2260 || (_circle2260 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2261 || (_circle2261 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2262 || (_circle2262 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2263 || (_circle2263 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2264 || (_circle2264 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2265 || (_circle2265 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2266 || (_circle2266 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2267 || (_circle2267 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2268 || (_circle2268 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2269 || (_circle2269 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 442.25,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2270 || (_circle2270 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.87,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2271 || (_circle2271 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2272 || (_circle2272 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2273 || (_circle2273 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2274 || (_circle2274 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2275 || (_circle2275 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2276 || (_circle2276 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2277 || (_circle2277 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2278 || (_circle2278 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2279 || (_circle2279 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2280 || (_circle2280 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2281 || (_circle2281 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2282 || (_circle2282 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2283 || (_circle2283 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2284 || (_circle2284 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2285 || (_circle2285 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.43,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2286 || (_circle2286 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2287 || (_circle2287 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2288 || (_circle2288 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2289 || (_circle2289 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2290 || (_circle2290 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2291 || (_circle2291 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2292 || (_circle2292 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2293 || (_circle2293 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2294 || (_circle2294 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.53,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2295 || (_circle2295 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.23,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2296 || (_circle2296 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.94,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2297 || (_circle2297 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2298 || (_circle2298 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2299 || (_circle2299 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2300 || (_circle2300 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2301 || (_circle2301 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2302 || (_circle2302 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2303 || (_circle2303 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2304 || (_circle2304 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2305 || (_circle2305 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2306 || (_circle2306 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2307 || (_circle2307 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 447.95,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2308 || (_circle2308 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2309 || (_circle2309 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2310 || (_circle2310 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2311 || (_circle2311 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2312 || (_circle2312 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2313 || (_circle2313 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2314 || (_circle2314 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2315 || (_circle2315 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2316 || (_circle2316 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2317 || (_circle2317 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2318 || (_circle2318 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2319 || (_circle2319 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2320 || (_circle2320 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2321 || (_circle2321 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2322 || (_circle2322 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2323 || (_circle2323 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2324 || (_circle2324 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2325 || (_circle2325 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2326 || (_circle2326 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2327 || (_circle2327 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2328 || (_circle2328 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2329 || (_circle2329 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2330 || (_circle2330 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2331 || (_circle2331 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2332 || (_circle2332 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2333 || (_circle2333 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2334 || (_circle2334 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 453.66,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2335 || (_circle2335 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.57,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2336 || (_circle2336 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2337 || (_circle2337 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2338 || (_circle2338 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2339 || (_circle2339 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2340 || (_circle2340 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2341 || (_circle2341 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2342 || (_circle2342 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2343 || (_circle2343 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2344 || (_circle2344 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2345 || (_circle2345 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2346 || (_circle2346 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2347 || (_circle2347 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2348 || (_circle2348 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2349 || (_circle2349 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2350 || (_circle2350 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2351 || (_circle2351 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2352 || (_circle2352 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2353 || (_circle2353 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2354 || (_circle2354 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2355 || (_circle2355 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2356 || (_circle2356 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2357 || (_circle2357 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2358 || (_circle2358 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2359 || (_circle2359 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2360 || (_circle2360 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 459.36,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2361 || (_circle2361 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2362 || (_circle2362 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2363 || (_circle2363 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2364 || (_circle2364 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2365 || (_circle2365 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2366 || (_circle2366 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2367 || (_circle2367 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2368 || (_circle2368 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2369 || (_circle2369 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2370 || (_circle2370 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2371 || (_circle2371 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2372 || (_circle2372 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2373 || (_circle2373 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2374 || (_circle2374 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2375 || (_circle2375 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2376 || (_circle2376 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2377 || (_circle2377 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2378 || (_circle2378 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2379 || (_circle2379 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2380 || (_circle2380 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2381 || (_circle2381 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2382 || (_circle2382 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.04,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2383 || (_circle2383 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2384 || (_circle2384 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2385 || (_circle2385 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2386 || (_circle2386 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2387 || (_circle2387 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2388 || (_circle2388 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2389 || (_circle2389 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2390 || (_circle2390 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 465.06,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2391 || (_circle2391 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2392 || (_circle2392 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2393 || (_circle2393 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2394 || (_circle2394 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2395 || (_circle2395 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2396 || (_circle2396 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2397 || (_circle2397 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2398 || (_circle2398 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2399 || (_circle2399 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2400 || (_circle2400 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2401 || (_circle2401 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2402 || (_circle2402 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.7,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2403 || (_circle2403 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2404 || (_circle2404 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2405 || (_circle2405 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2406 || (_circle2406 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2407 || (_circle2407 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2408 || (_circle2408 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2409 || (_circle2409 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2410 || (_circle2410 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.33,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2411 || (_circle2411 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2412 || (_circle2412 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2413 || (_circle2413 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2414 || (_circle2414 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2415 || (_circle2415 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2416 || (_circle2416 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2417 || (_circle2417 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2418 || (_circle2418 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2419 || (_circle2419 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 470.77,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2420 || (_circle2420 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2421 || (_circle2421 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2422 || (_circle2422 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2423 || (_circle2423 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2424 || (_circle2424 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2425 || (_circle2425 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2426 || (_circle2426 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2427 || (_circle2427 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2428 || (_circle2428 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2429 || (_circle2429 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2430 || (_circle2430 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2431 || (_circle2431 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2432 || (_circle2432 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2433 || (_circle2433 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2434 || (_circle2434 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2435 || (_circle2435 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2436 || (_circle2436 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2437 || (_circle2437 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2438 || (_circle2438 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2439 || (_circle2439 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2440 || (_circle2440 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2441 || (_circle2441 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2442 || (_circle2442 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2443 || (_circle2443 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2444 || (_circle2444 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2445 || (_circle2445 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2446 || (_circle2446 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2447 || (_circle2447 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2448 || (_circle2448 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2449 || (_circle2449 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 476.47,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2450 || (_circle2450 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2451 || (_circle2451 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2452 || (_circle2452 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2453 || (_circle2453 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2454 || (_circle2454 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2455 || (_circle2455 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2456 || (_circle2456 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2457 || (_circle2457 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2458 || (_circle2458 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2459 || (_circle2459 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.32,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2460 || (_circle2460 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.02,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2461 || (_circle2461 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2462 || (_circle2462 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2463 || (_circle2463 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2464 || (_circle2464 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2465 || (_circle2465 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2466 || (_circle2466 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2467 || (_circle2467 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.63,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2468 || (_circle2468 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2469 || (_circle2469 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.15,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2470 || (_circle2470 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2471 || (_circle2471 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2472 || (_circle2472 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2473 || (_circle2473 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2474 || (_circle2474 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2475 || (_circle2475 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2476 || (_circle2476 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2477 || (_circle2477 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2478 || (_circle2478 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2479 || (_circle2479 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2480 || (_circle2480 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2481 || (_circle2481 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 482.18,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2482 || (_circle2482 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2483 || (_circle2483 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2484 || (_circle2484 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2485 || (_circle2485 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2486 || (_circle2486 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2487 || (_circle2487 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2488 || (_circle2488 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2489 || (_circle2489 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2490 || (_circle2490 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2491 || (_circle2491 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2492 || (_circle2492 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2493 || (_circle2493 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2494 || (_circle2494 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2495 || (_circle2495 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2496 || (_circle2496 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.45,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2497 || (_circle2497 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2498 || (_circle2498 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2499 || (_circle2499 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2500 || (_circle2500 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2501 || (_circle2501 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2502 || (_circle2502 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2503 || (_circle2503 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2504 || (_circle2504 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2505 || (_circle2505 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2506 || (_circle2506 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2507 || (_circle2507 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2508 || (_circle2508 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2509 || (_circle2509 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 487.88,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2510 || (_circle2510 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2511 || (_circle2511 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2512 || (_circle2512 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2513 || (_circle2513 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2514 || (_circle2514 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2515 || (_circle2515 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2516 || (_circle2516 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2517 || (_circle2517 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2518 || (_circle2518 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2519 || (_circle2519 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2520 || (_circle2520 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2521 || (_circle2521 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2522 || (_circle2522 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2523 || (_circle2523 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2524 || (_circle2524 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2525 || (_circle2525 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2526 || (_circle2526 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2527 || (_circle2527 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2528 || (_circle2528 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2529 || (_circle2529 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2530 || (_circle2530 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2531 || (_circle2531 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2532 || (_circle2532 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2533 || (_circle2533 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2534 || (_circle2534 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2535 || (_circle2535 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2536 || (_circle2536 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 493.59,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2537 || (_circle2537 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2538 || (_circle2538 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2539 || (_circle2539 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2540 || (_circle2540 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2541 || (_circle2541 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2542 || (_circle2542 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2543 || (_circle2543 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2544 || (_circle2544 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.91,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2545 || (_circle2545 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2546 || (_circle2546 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2547 || (_circle2547 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2548 || (_circle2548 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2549 || (_circle2549 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.92,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2550 || (_circle2550 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2551 || (_circle2551 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2552 || (_circle2552 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2553 || (_circle2553 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2554 || (_circle2554 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.46,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2555 || (_circle2555 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.16,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2556 || (_circle2556 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2557 || (_circle2557 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2558 || (_circle2558 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2559 || (_circle2559 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2560 || (_circle2560 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2561 || (_circle2561 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2562 || (_circle2562 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 499.29,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2563 || (_circle2563 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2564 || (_circle2564 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2565 || (_circle2565 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2566 || (_circle2566 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2567 || (_circle2567 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2568 || (_circle2568 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2569 || (_circle2569 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.21,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2570 || (_circle2570 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2571 || (_circle2571 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.81,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2572 || (_circle2572 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.52,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2573 || (_circle2573 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.22,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2574 || (_circle2574 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2575 || (_circle2575 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2576 || (_circle2576 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.05,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2577 || (_circle2577 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.75,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2578 || (_circle2578 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.87,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2579 || (_circle2579 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2580 || (_circle2580 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2581 || (_circle2581 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2582 || (_circle2582 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2583 || (_circle2583 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2584 || (_circle2584 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 504.99,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2585 || (_circle2585 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2586 || (_circle2586 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2587 || (_circle2587 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2588 || (_circle2588 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2589 || (_circle2589 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2590 || (_circle2590 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2591 || (_circle2591 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2592 || (_circle2592 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.11,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2593 || (_circle2593 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.64,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2594 || (_circle2594 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.35,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2595 || (_circle2595 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.57,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2596 || (_circle2596 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.28,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2597 || (_circle2597 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2598 || (_circle2598 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2599 || (_circle2599 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2600 || (_circle2600 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.09,
    cy: 510.7,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2601 || (_circle2601 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 516.4,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2602 || (_circle2602 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 516.4,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2603 || (_circle2603 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 516.4,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2604 || (_circle2604 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 516.4,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2605 || (_circle2605 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 516.4,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2606 || (_circle2606 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 516.4,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2607 || (_circle2607 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.98,
    cy: 516.4,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2608 || (_circle2608 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 516.4,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2609 || (_circle2609 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 516.4,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2610 || (_circle2610 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.73,
    cy: 516.4,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2611 || (_circle2611 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 522.11,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2612 || (_circle2612 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 522.11,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2613 || (_circle2613 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 522.11,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2614 || (_circle2614 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 522.11,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2615 || (_circle2615 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.73,
    cy: 522.11,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2616 || (_circle2616 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 527.81,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2617 || (_circle2617 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 527.81,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2618 || (_circle2618 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 527.81,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2619 || (_circle2619 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39,
    cy: 527.81,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2620 || (_circle2620 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.68,
    cy: 527.81,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2621 || (_circle2621 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.39,
    cy: 527.81,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2622 || (_circle2622 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.02,
    cy: 527.81,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2623 || (_circle2623 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.73,
    cy: 527.81,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2624 || (_circle2624 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 533.52,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2625 || (_circle2625 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 533.52,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2626 || (_circle2626 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 533.52,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2627 || (_circle2627 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.32,
    cy: 533.52,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2628 || (_circle2628 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.02,
    cy: 533.52,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2629 || (_circle2629 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 539.22,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2630 || (_circle2630 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 539.22,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2631 || (_circle2631 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 539.22,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2632 || (_circle2632 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.61,
    cy: 539.22,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2633 || (_circle2633 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.32,
    cy: 539.22,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2634 || (_circle2634 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 544.92,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2635 || (_circle2635 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 544.92,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2636 || (_circle2636 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 544.92,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2637 || (_circle2637 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 550.63,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2638 || (_circle2638 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 550.63,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2639 || (_circle2639 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.28,
    cy: 556.33,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2640 || (_circle2640 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 556.33,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2641 || (_circle2641 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.09,
    cy: 556.33,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2642 || (_circle2642 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 556.33,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2643 || (_circle2643 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.69,
    cy: 562.04,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2644 || (_circle2644 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.73,
    cy: 562.04,
    r: 1.43,
    fill: "#c9bb60"
  })), _circle2645 || (_circle2645 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.98,
    cy: 567.74,
    r: 1.43,
    fill: "#c9bb60"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M526.06,296a8.84,8.84,0,0,0-8.91,8.73c0,6.54,8.91,16.2,8.91,16.2s8.9-9.66,8.9-16.2A8.83,8.83,0,0,0,526.06,296Zm0,11.84a3.12,3.12,0,1,1,3.18-3.11A3.12,3.12,0,0,1,526.06,307.87Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M526.06,295a8.84,8.84,0,0,0-8.91,8.73c0,6.54,8.91,16.2,8.91,16.2s8.9-9.66,8.9-16.2A8.83,8.83,0,0,0,526.06,295Zm0,11.84a3.12,3.12,0,1,1,3.18-3.11A3.12,3.12,0,0,1,526.06,306.87Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M526.06,456.47a8.85,8.85,0,0,0-8.91,8.73c0,6.55,8.91,16.21,8.91,16.21s8.9-9.66,8.9-16.21A8.84,8.84,0,0,0,526.06,456.47Zm0,11.85a3.12,3.12,0,1,1,3.18-3.12A3.12,3.12,0,0,1,526.06,468.32Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M526.06,455.47a8.85,8.85,0,0,0-8.91,8.73c0,6.55,8.91,16.21,8.91,16.21s8.9-9.66,8.9-16.21A8.84,8.84,0,0,0,526.06,455.47Zm0,11.85a3.12,3.12,0,1,1,3.18-3.12A3.12,3.12,0,0,1,526.06,467.32Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M725.34,279.63a8.84,8.84,0,0,0-8.91,8.72c0,6.55,8.91,16.21,8.91,16.21s8.9-9.66,8.9-16.21A8.83,8.83,0,0,0,725.34,279.63Zm0,11.84a3.12,3.12,0,1,1,3.18-3.12A3.12,3.12,0,0,1,725.34,291.47Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M725.34,278.63a8.84,8.84,0,0,0-8.91,8.72c0,6.55,8.91,16.21,8.91,16.21s8.9-9.66,8.9-16.21A8.83,8.83,0,0,0,725.34,278.63Zm0,11.84a3.12,3.12,0,1,1,3.18-3.12A3.12,3.12,0,0,1,725.34,290.47Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M943.16,529.13c-.22.1-.43.21-.65.3l.53.13Z",
    transform: "translate(-112.96 -29.97)",
    fill: "url(#840fda27-e84f-4eb3-b741-5710a211ee4f-101)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.55,519.53c-.76-4.44-14.87-14.06-14.87-14.06s-6.23-3.34-9.53-7.16c-2.11-2.44-2.77-2.42-3-2.08a1,1,0,0,0-.46-.16c-.13-.09-.26-.18-.38-.28l0,0a.9.9,0,0,0-.53-.91,5.41,5.41,0,0,1-.47-.31,14.88,14.88,0,0,1-1.59-6.53c-.16-2.79-3.37-2.08-4.42-1.78-.75-1.39-1.48-2.84-2.17-4.28a7.51,7.51,0,0,0,.75-1.5c2-4.24,1.54-9.11,2.4-13.6.59-3.1,1.78-6.31,1.67-9.37,0-.22,0-.44,0-.66v.05a8.62,8.62,0,0,0-.55-2.32c-.56-1.42-1.55-2.67-2-4.12-.72-2.15-.27-4.51-.85-6.68a10,10,0,0,0-5.73-6.09,28.83,28.83,0,0,0-8.49-2c-7.25-.9-14.95-1.43-21.56,1.59a3.88,3.88,0,0,1-2,.54,6.5,6.5,0,0,1-1.84-.84,5.57,5.57,0,0,0-5.59.85,16.46,16.46,0,0,0-3.72,4.49,14.6,14.6,0,0,1-3.84,4.39c-1.93,1.28-4.48,1.71-6,3.44a5.47,5.47,0,0,0-1.24,2.87.43.43,0,0,0,0-.05c0,.12,0,.25,0,.37s0,.21,0,.31a2.18,2.18,0,0,0,0,.25,7.79,7.79,0,0,0,0,.84,18.28,18.28,0,0,0,1.29,4.72,6.55,6.55,0,0,0,1.75,3c2.33,1.88,6,.11,8.82,1.15.24.09.47.2.71.31,0,.11-.07.21-.1.32a21.92,21.92,0,0,0-.91,6.25c0,12.47,10.42,22.58,23.26,22.58.48,0,.95,0,1.43-.05.07.25.14.5.2.74a24.38,24.38,0,0,1,.68,8.44l-.15-1.23a6,6,0,0,0-1-.37,8.58,8.58,0,0,0-2.89-.43c-3.16-.05-7.92,1.22-13,7.34,0,0-6.48,3.58-8.39,4.44a1,1,0,0,0-.35.4l0,0s-8.51,13.08-9.4,18-2,10.61-2,10.61-2.16,6.41-3.55,9.25-2.67,5.55-2.8,6.79.51,4-2.16,5.67-3.31,6.42-3.31,6.42-1.31,1.24-3.22,2.82a9.33,9.33,0,0,0-5.23,1.31c-2.48,1.62-5.49,3.45-7.93,5.37-6,.58-18,2.82-17.55,5.06.51,2.47-6.1,3.95-8.77,4.57-.68.15.12.76,1.48,1.73l-1-.18c-6.74-1.18-16-2.1-20.35.54-7.37,4.45-6.54,9.75.83,12.46,5.65,2.09,18.8,2.32,24.64,2.31h.76q-.35.33-.75.66s7.38,1.48,8.14,3.2,8.51-1,8.51-1,1.66-3.83,7.37-4.07,8.65-2.72,8.65-3.09,5.72-3.45,8.89-4.32c1.58-.43,3.4-.73,4.85-1-1.71,8.44-3.32,16.61-3.19,17.08,0,.19.35-.1.82-.74a3.1,3.1,0,0,0-.06.74c0,.13.18,0,.41-.22l0,.16s-9.91,19.06-10.68,21.29.19,7.77,3.24,9.62a6.62,6.62,0,0,1,1.57,1.37l-.36.72c-1.14,2.28-2.14,4.84-2,6.42a8.68,8.68,0,0,1-1.33,5.74s-8.58,26.37-8.39,34-3.05,24.25-3.05,24.25-3.53,10.73-1.43,13.79,4.48,16.38,4.48,16.38a13.45,13.45,0,0,1,1.52,5.64c-.09,2.59,1.53,7.31,1.53,7.31L946.24,778s-.57,5.09,1.43,8.7,1.81,2.5.85,8.79,1.15,12.12,4.58,14a2.07,2.07,0,0,1,1,2.88h0c-.87-.34-1.6,1.46-2,2.92-.26.26-.43.41-.43.41l.29.08c-.19.69-.29,1.22-.29,1.22s-9,7.4-9.54,10.09-6.86,4.07-6.86,4.07-9.53,2.59-12,3.88a4.5,4.5,0,0,0-2.63,3.59,9.87,9.87,0,0,0,.34,3.63c1,3.8,14.3,4.17,20.69,3.15s19.63-4.72,19.63-4.72,13.92-1.3,18-3,.85-5.92.85-5.92,0-.15,0-.4c.1-1.55.39-7.16-.6-8.67-.74-1.15-.72-4-.61-5.8,2.78-5-3.2-19.93-3.2-19.93s1.14-14.62.38-16.75-4-20.27-4-20.27-2-8.23-1.24-9.62-.48-5.37-.48-5.37-3.24-4.44-3-5.83-1-3.88-1-3.88,9.73-14.44,8.87-17.13.38-7,.38-7,1.23-2,2.71-4.49c1.8-3,4-6.6,4.73-7.72.93-1.43,3.18-7.51,4.44-11l.89-2.51s1.53,27.2,2.86,30,3.34,24.71,3.34,24.71a15,15,0,0,1,1,6.1c-.19,3.43,3,18.33,3,18.33s1.43,10.55.48,13.32-.19,23.23-.19,23.23-5.24,4-6.58,7,.19,11.39.19,11.39l.61.29a17.16,17.16,0,0,0-1.09,3.59c-.19,1.76-3.05,9.72-2.76,10.83s-1.24,4.54-1.43,6.29-2.57,4.35-2.76,5.28a23.06,23.06,0,0,1-1.06,2.44,23.59,23.59,0,0,0-1.23,3.76c-1,3.89,10.39,4.53,10.39,4.53,16.77,3.06,19.82-9.44,19.82-9.44s2.1-11.1,2.86-11.93a1.32,1.32,0,0,0,.13-1.06h0a14.36,14.36,0,0,0-2.41-5.23c-.54-.61-.58-2.2-.49-3.62a8.78,8.78,0,0,0,1.44-.26c6.77-2,4-13.14,4-13.14s4.58-7.41,4.58-10.28,1.62-11.66,1.62-11.66c5.81-10.36,3.53-35.53,4.48-37.57s-2-9.62-4.39-13-1.43-12.67,0-15.36-1.43-11.94-1.43-11.94,2.77-18,2.67-20.72,2.39-11,2.39-11,2.47-4.25,1.9-5.55,1.91-4.63,1.24-6.11.57-6,1.81-8.7a51.64,51.64,0,0,0,2-8.52c.07-.38.13-.75.2-1.11,2.78,1.74,5.31,3,6.25,2.69,1.7-.63-1-9.31-2.87-14.67.32-.24.45-.42.32-.5-1.14-.74.13-4.07.13-4.07,6.74-3.95,4.45-6.91,2.29-8.64s-.76-6.66-1.4-8.64.76-11,1.91-17.52a12.32,12.32,0,0,0,0-4.29c1.23-1.85,2.49-3.79,3.6-5.58,3.81-6.17,11.94-35.54,11.94-35.54l0-.15a40,40,0,0,0,1.7-3.67C1061.89,543.22,1057.31,524,1056.55,519.53Zm-59.23-16.91.18-.08s0,.1,0,.15Zm-37,315a3.24,3.24,0,0,1-1.21-.23Z",
    transform: "translate(-112.96 -29.97)",
    fill: "url(#198ff05b-1f86-443b-a19b-b69c2e52e16f-102)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M889.85,604.74c5.44,2.07,18.11,2.29,23.73,2.29,1.71,0,2.77,0,2.77,0l3.61-7.34-3.61-6.12s-3.3-.91-7.7-1.7c-6.49-1.17-15.36-2.09-19.59.54C882,596.79,882.75,602.05,889.85,604.74Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#fec2be"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M913.58,607c1.71,0,2.77,0,2.77,0l3.61-7.34-3.61-6.12s-3.3-.91-7.7-1.7C912.22,594.47,920.79,600.16,913.58,607Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M973.33,516.86l-1.6-1.84s-8.2,13-9.05,17.87-2,10.53-2,10.53-2.08,6.36-3.43,9.18-2.57,5.51-2.69,6.73.49,3.92-2.08,5.63-3.18,6.37-3.18,6.37-9.31,9-14.2,9.3-19,2.69-18.48,5.14-5.88,3.92-8.45,4.53,16.52,8,5.39,17.38c0,0,7.1,1.47,7.83,3.18s8.2-1,8.2-1,1.59-3.79,7.1-4,8.32-2.69,8.32-3.06,5.51-3.43,8.57-4.28,7.1-1.23,7.22-2.08,18.36-79.56,18.36-79.56Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#4c4981"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M973.33,516.86l-1.6-1.84s-8.2,13-9.05,17.87-2,10.53-2,10.53-2.08,6.36-3.43,9.18-2.57,5.51-2.69,6.73.49,3.92-2.08,5.63-3.18,6.37-3.18,6.37-9.31,9-14.2,9.3-19,2.69-18.48,5.14-5.88,3.92-8.45,4.53,16.52,8,5.39,17.38c0,0,7.1,1.47,7.83,3.18s8.2-1,8.2-1,1.59-3.79,7.1-4,8.32-2.69,8.32-3.06,5.51-3.43,8.57-4.28,7.1-1.23,7.22-2.08,18.36-79.56,18.36-79.56Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.05
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M992.39,856.51c16.15,3,19.09-9.37,19.09-9.37s2-11,2.76-11.84a1.38,1.38,0,0,0,.12-1h0a14.17,14.17,0,0,0-2.33-5.19c-1-1.19-.18-6.15-.18-6.15l-18.73-4.77a28.22,28.22,0,0,0-1.83,5.5c-.19,1.75-2.94,9.64-2.66,10.74s-1.2,4.5-1.38,6.25-2.48,4.31-2.66,5.23a23.9,23.9,0,0,1-1,2.42,24,24,0,0,0-1.19,3.73C981.46,855.86,992.39,856.51,992.39,856.51Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#ca8496"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M992.39,856.51c16.15,3,19.09-9.37,19.09-9.37s2-11,2.76-11.84a1.38,1.38,0,0,0,.12-1l-3.89,11.15s-3.21,6.7-15.14,5.69c-6.79-.57-10.14-1.83-11.76-2.81a24,24,0,0,0-1.19,3.73C981.46,855.86,992.39,856.51,992.39,856.51Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1005,839.07s-4,.09-4.31-3.22Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M944.06,532.2l.11-.43-.63.3Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M934.74,730.56c2,3,4.31,16.25,4.31,16.25a13.57,13.57,0,0,1,1.47,5.6c-.09,2.57,1.47,7.25,1.47,7.25l5.14,19s-.55,5.05,1.38,8.63,1.74,2.48.83,8.72,1.1,12,4.4,13.86-1.47,6.16-1.47,6.16,21.12,5.69,25.52,2.2-2.29-20.75-2.29-20.75,1.1-14.5.37-16.61S972,760.76,972,760.76s-1.93-8.17-1.19-9.54-.46-5.33-.46-5.33-3.12-4.4-2.85-5.78-.92-3.86-.92-3.86,9.37-14.32,8.54-17,.37-7,.37-7,1.18-2,2.61-4.46c1.74-3,3.84-6.55,4.55-7.66.9-1.42,3.07-7.44,4.28-10.91l.86-2.49s1.47,27,2.75,29.74S993.77,741,993.77,741a15.24,15.24,0,0,1,.91,6.06c-.18,3.39,2.94,18.17,2.94,18.17s1.38,10.47.46,13.22-.18,23-.18,23-5,4-6.34,7,.19,11.29.19,11.29,14.68,7.34,21.2,5.41,3.86-13,3.86-13,4.4-7.34,4.4-10.19,1.56-11.57,1.56-11.57c5.6-10.28,3.4-35.25,4.32-37.27s-1.93-9.54-4.22-12.94-1.38-12.57,0-15.24-1.38-11.84-1.38-11.84,2.66-17.81,2.57-20.56,2.29-10.93,2.29-10.93,2.39-4.22,1.84-5.5,1.84-4.59,1.19-6.06.55-6,1.75-8.63a52.77,52.77,0,0,0,2-8.46c.56-3.17,1-6,1-6l-15.14-12.21L981.1,624.9l-14.23-4.59L953,642.16s-1.43,2.28-2.7,4.92c-1.09,2.27-2.06,4.8-1.89,6.37a8.73,8.73,0,0,1-1.29,5.69s-8.26,26.17-8.08,33.69-2.93,24-2.93,24S932.72,727.53,934.74,730.56Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#ceddf9"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M990.66,517.77c.58-.23,40.51-16.72,35-20-3.26-1.95-7.27-10.19-10-16.65-1.92-4.51-3.22-8.14-3.22-8.14s-32-5.69-20.58,13.95a36.58,36.58,0,0,1,4,9.68C999.15,510,990.93,517.53,990.66,517.77Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#fec2be"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M991.84,486.93a36.58,36.58,0,0,1,4,9.68,22.39,22.39,0,0,0,18.93-13.3,23,23,0,0,0,.83-2.19c-1.92-4.51-3.22-8.14-3.22-8.14S980.37,467.29,991.84,486.93Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M971.92,473.53a22.38,22.38,0,1,0,.87-6.2A22.4,22.4,0,0,0,971.92,473.53Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#fec2be"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M950.31,647.08c2.35,2.13,3.25,6.19,3.25,6.19s11,7.53,10.28,2.75,5.69-24,5.69-24l-.73,26.26s35.25-1.66,37.82-4.23,17.62-7.52,17.62-7.52,4.61,3.7,8.85,6.5c.56-3.17,1-6,1-6l-15.14-12.21L981.1,624.9l-14.23-4.59L953,642.16S951.58,644.44,950.31,647.08Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M949.15,645c2.94,1.83,4,6.79,4,6.79s11,7.53,10.28,2.76,5.69-24.06,5.69-24.06l-.73,26.26s35.25-1.65,37.82-4.22,17.62-7.53,17.62-7.53,13,10.46,15.43,9.55-4.23-18.73-4.23-18.73l-6.79-104.28s1.84-31-.92-32.13a3.91,3.91,0,0,1-1.15-.72c-1.82-1.63-2.36-4.94-2.52-7.73-.18-3.3-4.59-1.65-4.59-1.65l2.57,3.31-22.75,13.83-.2.12a24,24,0,0,0-2.73-1.24c-2-.78-4.69-1.5-6.45-.78a6.24,6.24,0,0,0-2.41,2.17A27.07,27.07,0,0,0,984,513l-8.27,14s-4.22,18.54-4.22,19.28-1.28,17.62-2.75,19.46-2.94,11-2.39,13.77-.92,13-.92,13c-6.06,5-9.18,21.85-9.18,21.85s-9.54,18.91-10.28,21.11S946.22,643.17,949.15,645Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#fff"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M998.92,507.19c2.23,3.31,8.68,8,8.68,8l18.61-15.72c-1.82-1.63-2.36-4.94-2.52-7.72-.18-3.31-4.59-1.65-4.59-1.65l.53.68a3,3,0,0,1-.79,4.34Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M998.92,506.46c2.23,3.3,8.68,7.95,8.68,7.95l18.61-15.71c-1.82-1.63-2.36-4.94-2.52-7.73-.18-3.3-4.59-1.65-4.59-1.65l.53.69a3,3,0,0,1-.79,4.34Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#fff"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M990.32,508.93c2.4,2.88,5.81,6.14,5.65,4.5s2-5.24,3.43-6.85a10.13,10.13,0,0,0-6.67.18A6.17,6.17,0,0,0,990.32,508.93Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M990,507.83c2.4,2.88,5.81,6.14,5.65,4.5s1.81-4.27,3.2-5.89c-2-.78-4.69-1.5-6.44-.78A6.17,6.17,0,0,0,990,507.83Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#fff"
  })), _circle2646 || (_circle2646 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.01,
    cy: 491.66,
    r: 1.47,
    fill: "#ff718d"
  })), _circle2647 || (_circle2647 = /*#__PURE__*/React.createElement("circle", {
    cx: 871.87,
    cy: 531.32,
    r: 1.47,
    fill: "#ff718d"
  })), _circle2648 || (_circle2648 = /*#__PURE__*/React.createElement("circle", {
    cx: 859.26,
    cy: 571.46,
    r: 1.47,
    fill: "#ff718d"
  })), _circle2649 || (_circle2649 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.89,
    cy: 615.16,
    r: 1.47,
    fill: "#ff718d"
  })), _circle2650 || (_circle2650 = /*#__PURE__*/React.createElement("circle", {
    cx: 876.52,
    cy: 510.39,
    r: 1.47,
    fill: "#ff718d"
  })), _circle2651 || (_circle2651 = /*#__PURE__*/React.createElement("circle", {
    cx: 866.6,
    cy: 551.15,
    r: 1.47,
    fill: "#ff718d"
  })), _circle2652 || (_circle2652 = /*#__PURE__*/React.createElement("circle", {
    cx: 856.94,
    cy: 591.17,
    r: 1.47,
    fill: "#ff718d"
  })), _circle2653 || (_circle2653 = /*#__PURE__*/React.createElement("circle", {
    cx: 859.14,
    cy: 620.05,
    r: 1.47,
    fill: "#ff718d"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.2,499.6s-.24-2.2,2.94,1.59,9.18,7.1,9.18,7.1,13.58,9.55,14.32,14,5.14,23.5,2.81,29.86S1035.38,589,1035.38,589s4.65,5.51,3.55,12-2.45,15.42-1.84,17.38-.73,6.85,1.35,8.56,4.28,4.65-2.2,8.57c0,0-1.23,3.31-.13,4s-16.27,8.32-23.13,4.28-19.21-36.35-19.46-43.57,3.8-31.09,6-36.72,8.81-27.54,11.63-32.43S1026.2,499.6,1026.2,499.6Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M936.9,558.54a8.85,8.85,0,0,0-8.9,8.73c0,6.55,8.9,16.21,8.9,16.21s8.91-9.66,8.91-16.21A8.85,8.85,0,0,0,936.9,558.54Zm0,11.85a3.12,3.12,0,1,1,3.18-3.12A3.12,3.12,0,0,1,936.9,570.39Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.93,499.6s-.24-2.2,2.94,1.59,9.18,7.1,9.18,7.1,13.59,9.55,14.32,14,5.14,23.5,2.82,29.86S1036.11,589,1036.11,589s4.66,5.51,3.55,12-2.44,15.42-1.83,17.38-.74,6.85,1.34,8.56,4.29,4.65-2.2,8.57c0,0-1.22,3.31-.12,4s-16.28,8.32-23.13,4.28-19.22-36.35-19.46-43.57,3.79-31.09,6-36.72,8.82-27.54,11.63-32.43S1026.93,499.6,1026.93,499.6Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#4c4981"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.83,520.41s-10.53,11.63-10.16,19.34C1021.67,539.75,1021.55,527.26,1031.83,520.41Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.27,539.5c0,.37-7.1,26.81-6.74,30.11s-2.08,13.1-2.08,13.1l-3.3-.86s2.57-13.58,3.06-18.6S1017.27,539.5,1017.27,539.5Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.45,614.9c.25.37,16.77,19.09,12.12,20.44S1014.45,614.9,1014.45,614.9Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1028,610.13c.36.24,6.61,13.46,7.34,9.91s-5.39,9.67-6.36-.12Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M996.31,503.76s-6.83-4.16-15.4,6.49c0,0-6.24,3.55-8.07,4.41s-3.92,23.62-3.92,23.62-4,9.79-2.94,15.42-3.18,25-3.18,25-7.1,34.76-6.85,35.74,7.22-10.89,7.09-16.77,5.88-24.23,6.74-25.33,6.73-32.56,6.73-32.56,4.77-13.34,7.83-17.75,6.86-12.73,8.45-14.2a15.86,15.86,0,0,1,3.79-2.44Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M996.4,503.76s-7.65-4.16-16.22,6.49c0,0-6.24,3.55-8.08,4.41s-3.92,23.62-3.92,23.62-4,9.79-2.93,15.42-3.18,25-3.18,25-7.1,34.76-6.86,35.74,7.22-10.89,7.1-16.77,5.87-24.23,6.73-25.33,6.73-32.56,6.73-32.56,4.78-13.34,7.84-17.75,6.85-12.73,8.44-14.2a14.93,14.93,0,0,1,4.53-2.44Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#4c4981"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M962.8,580.26s-14.57-9.55-21.6-4.83-18.55,11.38-7.22,16.21,27,3.92,27,3.92Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#fec2be"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M972.93,672.36c2.17,4.66,4,28.06,5.18,35.48,1.74-3,3.84-6.55,4.55-7.66.9-1.42,3.07-7.44,4.28-10.91-1.38-3.37-5.2-13-5.2-16.54,0-4.31-7-9.73-7-9.73A8.1,8.1,0,0,0,972.93,672.36Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.74,744.24s-16.15-6.88-20.93-2S1019.74,744.24,1019.74,744.24Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.66,747s16.34,9.18,10.74,10.74S1010.66,747,1010.66,747Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M961.82,739s7,.46,4.31,1.83S961.82,739,961.82,739Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M953.1,741.12c.09.46,20.29,7,16.34,9.91S953.1,741.12,953.1,741.12Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.36,797.3c-3-.46-19.92-8.26-13.31-2.66A13.17,13.17,0,0,0,1017.36,797.3Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1009,803.45s-1.46,5.69-7.06,5S1009,803.45,1009,803.45Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.69,815c-1-.28-13-5.79-13.32-3.22s11.48,7.07,12.4,5.69A4.88,4.88,0,0,0,1013.69,815Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M974.76,808.41c-1.47-.1-15.23-4.5-18-.55Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M962.28,811s-2.39-2.12-4.77-1S962.28,811,962.28,811Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M992.76,833.74a4.11,4.11,0,0,1-3.13,3.21Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M922.72,842.37c.91,3.76,13.76,4.13,19.91,3.12s18.92-4.68,18.92-4.68,13.4-1.29,17.34-2.94.83-5.87.83-5.87,0-.15,0-.4c.09-1.53.37-7.1-.58-8.6-1.1-1.74-.46-7.43-.46-7.43s-19,3.67-19.37,1.92-3.3-4.22-4.68-4.77-2.39,4.59-2.39,4.59-8.63,7.34-9.18,10-6.61,4-6.61,4-9.18,2.57-11.56,3.85a4.45,4.45,0,0,0-2.54,3.56A10.16,10.16,0,0,0,922.72,842.37Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#ca8496"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M922.72,842.37c.91,3.76,13.76,4.13,19.91,3.12s18.92-4.68,18.92-4.68,13.4-1.29,17.34-2.94.83-5.87.83-5.87,0-.15,0-.4l-19.21,4.25s-9.46,4-15.52,4c-5.29,0-17.14,2.17-22.64-1.12A10.16,10.16,0,0,0,922.72,842.37Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M948.69,827.87s.92,6.06,4.59,8.07Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M972.79,467.33a6.1,6.1,0,0,0,1.09.45c1.72.46,3.41-.7,4.93-1.62s3.65-1.62,5-.42c1.73,1.57.48,4.92,2.25,6.44,1.13,1,2.91.63,4.17,1.42s1.62,2.51,1.94,4,1,3.19,2.42,3.63,2.8-.52,4.24-.47c.3,0,.65.05.85-.17a.9.9,0,0,0,.14-.67,14.13,14.13,0,0,1,.47-5.31,5.06,5.06,0,0,1,3.73-3.49c2.58-.4,4.74,1.86,6.26,4a67.21,67.21,0,0,1,4.34,7c.06.12.14.29.22.49a22.4,22.4,0,1,0-42-15.25Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.25,474.74c-1.52-2.13-3.68-4.38-6.26-4a5.1,5.1,0,0,0-3.73,3.49,14.15,14.15,0,0,0-.47,5.31.94.94,0,0,1-.14.67c-.21.22-.55.18-.85.17-1.43-.05-2.87.88-4.24.47s-2.1-2.13-2.42-3.63-.65-3.18-1.94-4-3-.46-4.17-1.42c-1.77-1.51-.52-4.87-2.25-6.43-1.32-1.2-3.44-.52-5,.41s-3.21,2.09-4.93,1.62a17.52,17.52,0,0,1-1.68-.7c-2.72-1-6.25.72-8.49-1.15a6.62,6.62,0,0,1-1.69-2.93,18.38,18.38,0,0,1-1.23-4.68,6.2,6.2,0,0,1,1.24-4.56c1.45-1.72,3.91-2.14,5.77-3.41a14.18,14.18,0,0,0,3.7-4.36,16.17,16.17,0,0,1,3.58-4.45,5.28,5.28,0,0,1,5.39-.85,5.74,5.74,0,0,0,1.77.84,3.63,3.63,0,0,0,2-.53c6.37-3,13.78-2.47,20.76-1.58a27.08,27.08,0,0,1,8.17,2,9.81,9.81,0,0,1,5.52,6c.57,2.16.13,4.5.82,6.63.46,1.44,1.42,2.68,2,4.09,1.49,3.87-.29,8.12-1,12.2-.82,4.45-.41,9.28-2.3,13.49-.37.83-.79,2.28-1.72,1.73-.69-.4-1.37-2.75-1.76-3.48A65.17,65.17,0,0,0,1010.25,474.74Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#9a5e7f"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.56,546.48l3.3,9.42s-7.83,29.13-11.5,35.25-9.06,14-9.06,14a33.6,33.6,0,0,1-19.58,2.45c-10.53-2.09-41.25-7.59-41.25-7.59a4.09,4.09,0,0,1-3.92-1.47c-1.34-2-8.32-2.94-8.32-2.94s-8.08-11.75,1.84-16.65c0,0,1.22,2.7,6.48.86s6.86,1.47,6.86,1.47,8.56,1.71,13.34,1.1,16.64-.86,17.87-1.83a1.56,1.56,0,0,1,2.2.12s2.94-1.1,3.92-2.2,2.32,1.22,2.32,1.22,1.72-1,1.23-2.2,1.59-5.88,1.59-5.88a11.84,11.84,0,0,0,.36-5.51c-.61-2.44,3.06-11.26,3.06-11.26a15.07,15.07,0,0,0-.49-4.4c-.61-2.21,4.66-6.61,4.66-6.61s5.14-25,16-16.77S1050.56,546.48,1050.56,546.48Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.29,546.48l3.31,9.42s-7.84,29.13-11.51,35.25-9.06,14-9.06,14a33.57,33.57,0,0,1-19.58,2.45c-10.53-2.09-41.25-7.59-41.25-7.59a4.07,4.07,0,0,1-3.91-1.47c-1.35-2-8.33-2.94-8.33-2.94s-8.07-11.75,1.84-16.65c0,0,1.22,2.7,6.49.86s6.85,1.47,6.85,1.47,8.57,1.71,13.34,1.1,16.65-.86,17.87-1.83a1.56,1.56,0,0,1,2.2.12s2.94-1.1,3.92-2.2,2.33,1.22,2.33,1.22,1.71-1,1.22-2.2,1.59-5.88,1.59-5.88a11.93,11.93,0,0,0,.37-5.51c-.61-2.44,3.06-11.26,3.06-11.26a15.48,15.48,0,0,0-.49-4.4c-.61-2.21,4.65-6.61,4.65-6.61s5.14-25,16-16.77S1051.29,546.48,1051.29,546.48Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#4c4981"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M971.73,585.89c.13.86,2.82,4.29,1.84,4.9s-2.57.24-1.1,2.2,1.35,4.9.37,4.53-2.57-4.77-2.57-6.49S971.73,585.89,971.73,585.89Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.09,583.93s.73,8.57,6.73,11S1008.09,583.93,1008.09,583.93Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.57,581c.37.12,8.57,4.52,4.9,7.09S1020.57,581,1020.57,581Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.06,574.88s12,2.44,8,4.52S1021.06,574.88,1021.06,574.88Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000.26,472.16a5.08,5.08,0,0,1,3.73-3.49c2.58-.39,4.74,1.86,6.26,4a65.17,65.17,0,0,1,4.34,7c.39.73,1.07,3.08,1.76,3.48.93.55,1.35-.9,1.72-1.73,1.89-4.21,1.48-9,2.3-13.49.48-2.6,1.38-5.27,1.58-7.87.28,3.2-1,6.57-1.58,9.83-.82,4.45-.41,9.28-2.3,13.49-.37.82-.79,2.28-1.72,1.73-.69-.41-1.37-2.75-1.76-3.49a66,66,0,0,0-4.34-7c-1.52-2.13-3.68-4.39-6.26-4a5.06,5.06,0,0,0-3.73,3.49,9.52,9.52,0,0,0-.49,2.75A12.65,12.65,0,0,1,1000.26,472.16Z",
    transform: "translate(-112.96 -29.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962,460.54a6.6,6.6,0,0,0,1.69,2.94c2.24,1.87,5.77.11,8.49,1.15a17.52,17.52,0,0,0,1.68.7c1.72.47,3.41-.69,4.93-1.62s3.65-1.61,5-.41c1.73,1.56.48,4.92,2.25,6.43,1.13,1,2.91.63,4.17,1.42s1.62,2.51,1.94,4,1,3.19,2.42,3.63,2.81-.52,4.24-.47c.3,0,.64.05.85-.17a.77.77,0,0,0,.1-.18c0,.49,0,1,0,1.47a.94.94,0,0,1-.14.67c-.21.22-.55.18-.85.17-1.43,0-2.87.88-4.24.47s-2.1-2.13-2.42-3.63-.65-3.19-1.94-4-3-.46-4.17-1.42c-1.77-1.51-.52-4.87-2.25-6.44-1.32-1.2-3.44-.51-5,.42s-3.21,2.08-4.93,1.62a15.36,15.36,0,0,1-1.68-.71c-2.72-1-6.25.72-8.49-1.14A6.6,6.6,0,0,1,962,462.5a18.2,18.2,0,0,1-1.23-4.67,7.49,7.49,0,0,1,0-1.64A20.22,20.22,0,0,0,962,460.54Z",
    transform: "translate(-112.96 -29.97)"
  }))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M883.35,580.59a8.84,8.84,0,0,0-3.21,12c3.34,5.63,15.92,9.4,15.92,9.4s2.74-12.86-.6-18.49A8.84,8.84,0,0,0,883.35,580.59Zm6,10.19a3.12,3.12,0,1,1,1.15-4.31A3.13,3.13,0,0,1,889.39,590.78Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M910.08,576.93a8.83,8.83,0,0,0-11.2,5.47c-2.08,6.2,3.31,18.19,3.31,18.19s11.51-6.35,13.58-12.56A8.85,8.85,0,0,0,910.08,576.93Zm-3.74,11.24a3.12,3.12,0,1,1,4-1.95A3.11,3.11,0,0,1,906.34,588.17Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#c9bb60"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.83,
    cy: 836.29,
    rx: 38.16,
    ry: 3.77,
    fill: "#c9bb60",
    opacity: 0.1
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M328.17,846.71s15.36-.47,20-3.76,23.63-7.24,24.77-2,23.09,26.29,5.75,26.43-40.3-2.7-44.92-5.51S328.17,846.71,328.17,846.71Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#a8a8a8"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M379,865.59c-17.34.14-40.3-2.7-44.92-5.51-3.51-2.15-4.92-9.84-5.39-13.39l-.51,0s1,12.39,5.59,15.21,27.58,5.65,44.92,5.51c5,0,6.73-1.82,6.64-4.46C384.62,864.57,382.71,865.56,379,865.59Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.46,
    cy: 791.55,
    rx: 28.04,
    ry: 2.77,
    fill: "#c9bb60",
    opacity: 0.1
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M397,807.16s11.29-.35,14.69-2.77S429,799.08,429.88,803s17,19.32,4.21,19.43-29.6-2-33-4.06S397,807.16,397,807.16Z",
    transform: "translate(-112.96 -29.97)",
    fill: "#a8a8a8"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M434.32,821c-12.74.11-29.61-2-33-4-2.59-1.57-3.62-7.23-4-9.83H397s.72,9.1,4.11,11.17,20.26,4.16,33,4.06c3.68,0,5-1.34,4.88-3.28C438.46,820.28,437.06,821,434.32,821Z",
    transform: "translate(-112.96 -29.97)",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg-2.d9b74408eef1c7f689965d81f0e6c5aa.svg";
export { ForwardRef as ReactComponent };